const angular = require('angular');
const _ = require('lodash');
import { getAllValueSetterControlName } from '../blockly/blockly.component';
import * as moment from 'moment';
/**
 * Propertybox for defining properties for selected control.
 *
 * @export
 * @class PropertyboxComponent
 */
export class PropertyboxComponent {

    /**
     * Stores available controls
     *
     * @type {*}
     * @memberOf PropertyboxComponent
     */
    models: any;
    /**
     * Localstorage instance
     *
     * @type {*}
     * @memberOf PropertyboxComponent
     */
    store: any;
    /**
     * Accordian is Open one at a time?
     *
     * @type {Boolean}
     * @memberOf PropertyboxComponent
     */
    oneAtATime: Boolean;
    /**
     * Property section visibility
     *
     * @type {Array<Boolean>}
     * @memberOf PropertyboxComponent
     */
    isOpen: Array<Boolean>;
    /**
     * Angular HTTP module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $http: any;
    /**
     * Available Data Source from server
     *
     * @type {Array<any>}@memberof PropertyboxComponent
     */
    availableDS: Array<any>;
    /**
     * Angular $filter module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $filter: any;
    /**
     * Notification module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    ngNotification: any;
    /**
     * UIB Modal popup module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $uibModal: any;
    /**
     * Angular $document module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $document: any;
    /**
     * Selected view from view-manager
     *
     * @type {*}@memberof PropertyboxComponent
     */
    selectedView: any;
    /**
     * Utility service
     *
     * @type {*}@memberof PropertyboxComponent
     */
    Util: any;
    /**
     * Supported Languages
     *
     * @type {*}@memberof PropertyboxComponent
     */
    SupportedLanguages: any = [
        {
            "displayCountry": "United Kingdom",
            "languageId": "en_GB",
            "displayLanguage": "English"
        },
        {
            "displayCountry": "United States",
            "languageId": "en_US",
            "displayLanguage": "English"
        },
        {
            "displayCountry": "Canada",
            "languageId": "en_CA",
            "displayLanguage": "English"
        },
        {
            "displayCountry": "France",
            "languageId": "fr_FR",
            "displayLanguage": "Français"
        },
        {
            "displayCountry": "Russia",
            "languageId": "ru_RU",
            "displayLanguage": "Русский"
        },
        {
            "displayCountry": "Spain",
            "languageId": "es_ES",
            "displayLanguage": "Español"
        },
        {
            "displayCountry": "Australia",
            "languageId": "en_AU",
            "displayLanguage": "English"
        },
        {
            "displayCountry": "China",
            "languageId": "zh_CN",
            "displayLanguage": "中文"
        },
        {
            "displayCountry": "Germany",
            "languageId": "de_DE",
            "displayLanguage": "Deutsch"
        },
        {
            "displayCountry": "Ireland",
            "languageId": "ga_IE",
            "displayLanguage": "Gaeilge"
        },
        {
            "displayCountry": "South Africa",
            "languageId": "en_ZA",
            "displayLanguage": "English"
        }
    ];
    /**
     * Language Object with all the edited languages included
     *
     * @type {*}@memberof PropertyboxComponent
     */
    LanguageObject: any;

    /**
     * Angular $window module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $window: any;
    /**
     * Angular $rootScope module
     *
     * @type {*}@memberof PropertyboxComponent
     */
    $rootScope: any;
    /**
     * Color picker default options
     *
     * @memberof PropertyboxComponent
     */
    colorPickerOptions = {
        showButtons: false,
        replacerClassName: 'spectrum-color-picker',
        containerClassName: 'spectrum-color-picker-container'
    };
    /**
     * Color picker evnet object
     *
     * @type {*}@memberof PropertyboxComponent
     */
    colorPickerEventApi: any;
    /**
     * Date picker default options
     *
     * @type {*}@memberof PropertyboxComponent
     */
    dateOptions: any = {
        formatDay: 'dd',
        formatMonth: 'MMM',
        formatYear: 'yyyy',
        showWeeks: false
    };
    datePickerOptions : any ;
    timePickerOptions :any = {
        showMeridian: true
    }
    timeFormat:string = 'HH:mm'
    hideProperties: boolean;
    config: any;
    views: any;
    basicSelected: boolean;
    $translate:any;
    numberFormatEnabled: boolean = false;
    cellColor: any = 'rgba(255, 255, 255, 0)';
    multiCellObject: any = [];
    fieldName;
    /**
     * Basic sections list
     *
     * @type {*}
     * @memberof PropertyboxComponent
     */
    basicFields: any = ["Basic", "Display", "control.style", "label.style", "switch.style","padding", "style", "row.style", "Size", "Borders", "Merge", "File Attributes Setup", "Form Fields Setup","Add/Edit Fields"];

    /**
     * Advance sections list
     *
     * @type {*}
     * @memberof PropertyboxComponent
     */
    advancedFields: any = ["Advanced", "datasource", "Events"];

    /**
     * Code editor instance
     *
     * @type {*}
     * @memberof PropertyboxComponent
     */
    codeEditor: any;

    typeWiseDataFieldNameAllowed : any = {
        'Attachment' : ['Attachment'],
        'Signature': ['Signature'],
        'Rich-Text-Box': ['Rich-Text-Box'],
        'Textbox': ['Textbox', 'Text-Area'],
        'Text-Area': ['Textbox', 'Text-Area'],
        'Map': ['Map'],
        'Dropdown': ['Dropdown'],
        'MultiDropdown': ['MultiDropdown'],
        'Datepicker': ['Datepicker'],
        'Checkbox': ['Checkbox'],
        'Radio': ['Radio'],
        'ToggleButton': ['ToggleButton'],
        'Timepicker': ['Timepicker'],
        'Rating': ['Rating'],
        'InlineAssocFiles': ['InlineAssocFiles'],
        'InlineAssocApps': ['InlineAssocApps'],
        'ViewAssociations': ['ViewAssociations']
    };

    /**
     * Creates an instance of PropertyboxComponent.
     *
     * @param {any} localStorage
     *
     * @memberOf PropertyboxComponent
     */
    constructor(localStorage, $http, $filter, Notification, $uibModal, $document, Util, $window, $translate, $rootScope, config, $scope, $sce, $timeout) {
        this.Util = Util;
        this.config = config;
        this.hideProperties = false;
        this.basicSelected = false;
        this.$document = $document;
        this.$uibModal = $uibModal;
        this.$http = $http;
        this.$filter = $filter;
        this.store = localStorage;
        this.$translate=$translate;
        this.selectedView = this.store.get('selectedView');
        this.views = this.store.get('views');
        this.numberFormatEnabled = this.store.get("numberFormatEnabled");

        this.models = this.store.get('components');
        this.availableDS = [];

        this.oneAtATime = true;
        this.isOpen = [true];
        this.ngNotification = Notification;
        this.$window = $window;
        this.$rootScope = $rootScope;
        let self = this;
        this.colorPickerEventApi = {
            onChange: function (type) {
                //self.updateStyle(type);
            }
        }

        self.$rootScope.$on('controlValueChanged', (event, properties) => {
            self.updateDSField(properties);
            self.onPropValueChanged();
        });
        this.datePickerOptions = {
            format:this.Util.getNewDateFormat('default'),
            showClear:true,
            showClose:true,
            showTodayButton:true,
            allowInputToggle:true,
            useCurrent:false,
            sideBySide:true,
            keepOpen: false,
            toolbarPlacement: "bottom",
            locale: this.config.languageId.split('_')[0],
            icons: {
              close: 'closeText',
              clear: 'clearText',
              today: 'todayText'
            }
        };

        $scope.htmlPopover = $sce.trustAsHtml(self.$translate.instant('popover.fieldname'));
        $scope.htmlPopoverForFitScreen = $sce.trustAsHtml(self.$translate.instant('popover.fit.to.screen'));
        $scope.htmlPopoverForRatingProps = $sce.trustAsHtml(self.$translate.instant('popover.rating'));
        $scope.htmlPopoverForRatingValueProps = $sce.trustAsHtml(self.$translate.instant('value.popover.rating'));
        $scope.htmlPopoverForWorkingDays = $sce.trustAsHtml(self.$translate.instant('popover.working.days'));
        $scope.htmlPopoverForEmbeddedAttachment = $sce.trustAsHtml(self.$translate.instant('popover-embedded-attachment'));
        var digestTimeOut;
        this.$rootScope.$on('controlChanged', function (event, args) {
            self.basicSelected = false;
            digestTimeOut && $timeout.cancel(digestTimeOut);
            digestTimeOut = $timeout(function () {
                let sItem = self.getSelectedItem();
                if(sItem.type == 'Datepicker') {
                    let _allprops = self.getSelectedItemProperties();
                    let pickerId = self.getSelectedItem().uid,
                     _props = _allprops['Basic'],
                    myPropDateElem = angular.element("input[picker-id=p_"+pickerId+"]"),
                    dateTimeFormat = _props['Display Format'].selectedValue == 'default' ? self.Util.getNewDateFormat('default') : _props['Display Format'].selectedValue;
                    if(_props['Time'] && _props['Time'].selectedValue)  {
                        dateTimeFormat = _props['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
                    }
                    myPropDateElem.datetimepicker('destroy');
                    self.datePickerOptions.format = dateTimeFormat;
                    // Reinitialize with new options
                    myPropDateElem.datetimepicker(self.datePickerOptions);
                }
                if (sItem && (sItem.type === 'InlineAssocFiles' || sItem.type === 'InlineAssocApps')) {
                    self.updateLanguageData(sItem);
                }
                $scope.$digest();
            }, 100);
    
        });

        this.$rootScope.$on('numberFormatEnabledChanged',  () => {
            self.numberFormatEnabled = self.store.get("numberFormatEnabled");
        });
        $scope.htmlPopoverForDataFieldName =$sce.trustAsHtml(self.$translate.instant('popover.data.fieldname'));
    }

    maximizedCodeEditor: boolean = false;

    updateLanguageData(selectedItem) {
        const languageData = this.store.get('Languages') || {};
        const viewName = selectedItem.viewName;
        const uid = selectedItem.uid;
        const textValue = selectedItem.properties.Basic.Text.selectedValue;

        // Key format for InlineAssocFiles/Apps
        const textKey = `${viewName}_InlineAssoc_${uid}`;

        if (!languageData['Default']) {
            languageData['Default'] = {};
        }
        if (!languageData['Default'][textKey]) {
            languageData['Default'][textKey] = textValue;
        } else if (languageData['Default'] && languageData['Default'][textKey]) {
            languageData['Default'][textKey] = textValue;
        }

        // Save updated language data
        this.store.set('Languages', languageData);
    }

    /**
     * @brief      Open model dialog which contains code editor as body content
     *
     * @return     null
     */
    openCodeEditorDialog(eventDetail) {
        let self = this;
        let codeEditorModalInstance = self.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'codeEditor.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            windowClass: 'code-editor-modal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                this.maximized = false;
                this.showSpinner = true;
                self.maximizedCodeEditor = false;
                angular.element(window).on('resize', () => {
                    self.codeEditorResizeHandler();
                });
                window.setTimeout(() => {
                    self.codeEditorResizeHandler();
                    self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
                    self.codeEditor.setVal(eventDetail.xmlValue);
                }, 10);
                
                document.body.style.overflow = 'hidden';

                this.isPasteDisabled = function() {
                    if(self.$window.localStorage.getItem('domXml')) {
                      return false;
                    }
                    return true;
                }

                this.copyBlockly = function(){
                    self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
                    let valObJ = self.codeEditor.getVal(true);
                    self.Util.setBlocklyBlock(valObJ);
                }

                this.pasteBlockly = function(){
                    try {
                        self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
                        let newDomBlock = self.Util.getBlocklyBlock();
                        self.codeEditor.setVal(newDomBlock);
                    } catch(error) {
                        self.ngNotification.error({ message: error.message.split('and')[0], positionX: 'center', replaceMessage: true });
                    }
                }

                this.save = function () {
                    //Read and Validate value from Blockly Eitor and save it
                    let valObJ = self.codeEditor.getVal(true);
                    if(valObJ.isAPIInProgress) {
                        self.ngNotification.error({ message: 'API call is in progress ', positionX: 'center', replaceMessage: true });
                        return;
                    }
                    let infiniteLoopPath;
                    if(eventDetail.name == 'onChange') {
                        infiniteLoopPath = self.getInfiniteLoopToChangeValue(valObJ.xmlVal);
                    }
                    if(infiniteLoopPath) {
                        self.ngNotification.error({
                            message: `Please ckeck your code. We detect a infinite loop to change value. Path : ${infiniteLoopPath}`,
                            positionX: 'center',
                            replaceMessage: true
                        });
                    } else {
                        eventDetail.selectedValue = valObJ.scriptVal;
                        eventDetail.xmlValue = valObJ.xmlVal;
                        eventDetail.systemFields = valObJ.systemFields;
                        eventDetail.autoNumberFieldDetail = valObJ.autoNumberFieldDetail;
                        self.updateAllReadonlyControlEventsProperty(eventDetail);
                        codeEditorModalInstance.close();
                        self.destroyCodeEditor();
                    }
                };

                /**
                 * @brief      Close dialog
                 * @return     NULL
                 */
                this.cancel = function () {
                    // codeEditorModalInstance.dismiss('cancel');
                    codeEditorModalInstance.close(false);
                    self.destroyCodeEditor();
                };

                this.maximize = () => {
                    this.maximized = true;
                    self.maximizedCodeEditor = true;
                    self.codeEditorResizeHandler();
                };
        
                this.minimize = () => {
                    this.maximized = false;
                    self.maximizedCodeEditor = false;
                    self.codeEditorResizeHandler();
                };
            }
        });
    }

    valChangeControlsNameData: any

    /**
     * @brief      Find out value change event infinite loop path 
     *
     * @return     Array of control names which generate infinite loop
     */
    getInfiniteLoopToChangeValue(xmlVal) {
        let self = this;
        let controlName = self.getSelectedControlFieldName();
        self.valChangeControlsNameData = {};
        self.valChangeControlsNameData[controlName] = {};
        self.getDeepLevelValueSetterControlName(self.valChangeControlsNameData[controlName], undefined, xmlVal);
        return self.getInfiniteLoopPath();
    }

    /**
     * @brief      Set value chagne control name into instance variable. If control name is passed and XmlVal is not defined that findout xmlVal using control name
     *
     * @return     null
     */
    getDeepLevelValueSetterControlName(data, controlName?, xmlVal?) {
        let self = this;
        if(!xmlVal && controlName) {
            let properties = self.getProperties(controlName);
            xmlVal = properties && properties.Events.change && properties.Events.change.xmlValue;
        }

        let controlNames = getAllValueSetterControlName(xmlVal);
        controlNames.forEach((name) => {
            data[name] = {};
            if(!self.getInfiniteLoopPath()) {
                self.getDeepLevelValueSetterControlName(data[name], name);
            }
        });
    }
    
    /**
     * @brief      Generate path for each branch of object
     *
     * @return     Array of uniq path of each branch of object
     */
    getPath(object) {
        function iter(obj, path)  {
            let keys = Object.keys(obj);
            if (keys.length) {
                return keys.forEach(function (k) {
                    iter(obj[k], path.concat(k));        
                });
            }
            result.push(path);
        }
    
        let result = [];
        iter(object, []);
        return result;
    }

    /**
     * @brief      Find out one of the infinite loop path
     *
     * @return     Array of path (control name) which generate infinite loop
     */
    getInfiniteLoopPath() {
        let self = this;
        let paths = self.getPath(self.valChangeControlsNameData);
        let infiniteLoop;
        paths.some((path) => {
            if(path.length !== _.uniq(path).length) {
                infiniteLoop = path;
                return true;
            }
        });
        return infiniteLoop;
    }

    codeEditorResizeHandler() {
        let width = (this.maximizedCodeEditor) ? window.innerWidth : Math.min(1280, window.innerWidth);
        let height = (this.maximizedCodeEditor) ? window.innerHeight : Math.min(600, window.innerHeight);
        let margin = (this.maximizedCodeEditor) ? 10 : (width <= 768) ? 10 : 30;
        angular.element('.form-builder .code-editor-modal .modal-dialog').css({
        'width': (width - (margin * 2)) + 'px',
        'height': (height - (margin * 2)) + 'px',
        'marginTop': margin + 'px',
        'marginBottom': margin + 'px'
        });
    }

    /**
     * @brief      Destroy existing code editer intanceview.
     *
     * @return     null
     */
    destroyCodeEditor() {
        let self = this;
        document.body.style.overflow = '';
        self.codeEditor.destroyCodeEditor();
        self.codeEditor = undefined;
        angular.element(window).off('resize');
    }

    /**
     * @brief      Opens a language dialog.
     *
     * @return     null
     */
    openLanguageDialog(fieldname,propertyField) {
        let self = this;
        let selectedItem = self.getSelectedItemProperties();
        let uid = self.getSelectedItem().uid;

        let value = '';
        
        if(propertyField.name == 'labelon') {
            value = selectedItem.Basic.LabelOn.selectedValue;
        } else if(propertyField.name == 'labeloff') {
            value = selectedItem.Basic.LabelOff.selectedValue;
        } else if(propertyField.name == 'displayLabel') {
            value = selectedItem.Basic.DisplayLabel.selectedValue;
        } else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps')) {
            if(propertyField['name'] === 'text') {
                value = selectedItem.Basic.Text.selectedValue;
            } else {
                value = selectedItem.Basic.Label.selectedValue;
            }
        } else {
            if (selectedItem.Basic.Label) {
                value = selectedItem.Basic.Label.selectedValue;
            } 
            if (selectedItem.Basic.Text) {
                value = selectedItem.Basic.Text.selectedValue;
            }
        }

        this.LanguageObject = this.store.get('Languages') || {};

        let LanguageModalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'languageModal.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                this.supportedLanguages = angular.copy(self.Util.supportedLanguages);
                this.languageObj = {
                    'Default': {
                        displayCountry: "Default",
                        displayLanguage: "Default",
                        languageId: "Default",
                        label: value
                    }
                };

                for (var i = 0; i < this.supportedLanguages.length; i++) {
                    let language = this.supportedLanguages[i];
                    this.languageObj[language.languageId] = language;
                    if(propertyField.name == 'labelon' || propertyField.name == 'labeloff' || propertyField.name == 'displayLabel') {
                        this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_'+ propertyField.name +'_' + uid] || '';
                    } else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField.name === 'text') {
                       this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_InlineAssoc_' + uid] || '';
                    } else {
                        this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_' + uid] || '';

                    }
                }

                /**
                 * @brief      Re-oraganize language JSON
                 *             And Send it to parent controller.
                 *
                 * @return     NULL
                 */
                this.save = function () {
                    for (var lang in this.languageObj) {
                        if(propertyField.name == 'labelon' || propertyField.name == 'labeloff' || propertyField.name == 'displayLabel') {
                            if (this.languageObj[lang].label) {
                                this.languageObj[lang][self.selectedView.view.viewName + '_'+propertyField.name+'_' + uid] = this.languageObj[lang].label;
                            } else {
                                delete this.languageObj[lang][self.selectedView.view.viewName + '_'+propertyField.name+'_' + uid];
                            }
                        } else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField['name'] === 'text') {
                            if (this.languageObj[lang].label) {
                                this.languageObj[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid] = this.languageObj[lang].label;
                            } else {
                                delete this.languageObj[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid];
                            }
                        } else {
                            if (this.languageObj[lang].label) {
                                this.languageObj[lang][self.selectedView.view.viewName + '_' + uid] = this.languageObj[lang].label;
                            } else {
                                delete this.languageObj[lang][self.selectedView.view.viewName + '_' + uid];
                            }
    
                        }
                        
                        delete this.languageObj[lang].label;
                        delete this.languageObj[lang].displayCountry;
                        delete this.languageObj[lang].displayLanguage;
                        delete this.languageObj[lang].languageId;
                    }
                    LanguageModalInstance.close(this.languageObj);
                };

                /**
                 * @brief      Close language dialog
                 *
                 * @return     NULL
                 */
                this.cancel = function () {
                    // LanguageModalInstance.dismiss('cancel');
                    LanguageModalInstance.close(false);
                };
            }
        });

        LanguageModalInstance.result.then((selectedItem) => {
            for (var lang in selectedItem) {
                self.LanguageObject[lang] = self.LanguageObject[lang] || {};     
                if (Object.keys(selectedItem[lang]).length > 0) {
                    angular.merge(self.LanguageObject[lang], selectedItem[lang]);
                } else {
                    const keyToDelete = propertyField.name === 'labelon' || propertyField.name === 'labeloff' || propertyField.name === 'displayLabel'
                        ? self.selectedView.view.viewName + '_' + propertyField.name + '_' + uid
                        : self.selectedView.view.viewName + '_' + uid;
            
                    if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField['name'] === 'text') {
                        Object.keys(self.LanguageObject[lang]).length > 0 && delete self.LanguageObject[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid];
                    }

                    if (Object.keys(self.LanguageObject[lang]).length > 0) {
                        delete self.LanguageObject[lang][keyToDelete];
                    }
                }
            }
            this.store.set('Languages', self.LanguageObject);
            if(propertyField.name == 'labelon') {
                self.getSelectedItemProperties().Basic.LabelOn.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_labelon_' + uid];
            } else if(propertyField.name == 'labeloff'){
                self.getSelectedItemProperties().Basic.LabelOff.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_labeloff_' + uid];
            } else if(propertyField.name == 'displayLabel') {
                self.getSelectedItemProperties().Basic.DisplayLabel.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_displayLabel_' + uid];
            } else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps')) {
                if (propertyField['name'] === 'text') {
                   let asocId = self.selectedView.view.viewName && self.selectedView.view.viewName + '_InlineAssoc_' + uid;
                   asocId && self.LanguageObject['Default'][asocId] && (self.getSelectedItemProperties().Basic.Text.selectedValue = self.LanguageObject['Default'][asocId]);
                } else {
                    self.getSelectedItemProperties().Basic.Label.selectedValue = self.LanguageObject['Default'] && self.LanguageObject['Default'][self.selectedView.view.viewName + '_' + uid]
                }
            } else {
                const labelKey = self.selectedView.view.viewName + '_' + uid;
                const selectedValue = (self.LanguageObject['Default'] && self.LanguageObject['Default'][labelKey]) || '';

                const itemProperties = self.getSelectedItemProperties().Basic;
                if (itemProperties.Label) {
                    itemProperties.Label.selectedValue = selectedValue;
                } else {
                    itemProperties.Text.selectedValue = selectedValue;
                }
            }
        }, function () {
            console.log('Modal dismissed at: ' + new Date());
        });
    }

    
    /**
     * @brief      Opens a language dialog for number separator.
     *
     * @return     null
     */
     openLanguageDialogForNumberSeparator(values) {
        let self = this;
        let LanguageModalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'languageNumberSeparatorModal.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            windowClass: 'number-separator-modal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                this.supportedLanguages = angular.copy(self.Util.supportedLanguages);
                this.allowDecimalSeparator = values.Validate.selectedValue == 'Decimal';
                let decimalThousandSeparator = values.DecimalThousandSeparator.selectedValue;
                this.languageObj = {
                    'Default': angular.copy(decimalThousandSeparator.Default)
                };

                if(this.languageObj['Default'] && this.languageObj['Default'].thousand == ' ') {
                    this.languageObj['Default'].thousand = 'SPACE';
                }

                for (var i = 0; i < this.supportedLanguages.length; i++) {
                    let language = this.supportedLanguages[i];
                    this.languageObj[language.languageId] = language;
                    this.languageObj[language.languageId].decimal = decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].decimal || '';
                    if(decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].thousand == ' ') {
                        decimalThousandSeparator[language.languageId].thousand = 'SPACE';
                    }
                    this.languageObj[language.languageId].thousand = decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].thousand || '';
                }

                /**
                 * @brief      Re-oraganize language JSON
                 *             And Send it to parent controller.
                 *
                 * @return     NULL
                 */
                this.save = function () {

                    if(this.allowDecimalSeparator) {
                        let sameValueForDecimalAndThoudSeparator = [];
                        for (var lang in this.languageObj) {
                            if(this.languageObj[lang].decimal && this.languageObj[lang].thousand && this.languageObj[lang].decimal == this.languageObj[lang].thousand || 
                                ((this.languageObj['Default'].decimal == this.languageObj[lang].thousand) && this.languageObj[lang].decimal=="") ||
                                ((this.languageObj['Default'].thousand == this.languageObj[lang].decimal) && this.languageObj[lang].thousand == "") ) {
                                sameValueForDecimalAndThoudSeparator.push(this.languageObj[lang].displayCountry);
                            }
                        }

                        if(sameValueForDecimalAndThoudSeparator.length) {
                            self.ngNotification.error({
                                message: `Please enter a different value for these contries. ${sameValueForDecimalAndThoudSeparator.join(', ')}` ,
                                positionX: 'center',
                                replaceMessage: true
                            });
                            return;
                        }
                    }

                    for (var lang in this.languageObj) {
                        if(!values.DecimalThousandSeparator.selectedValue[lang]) {
                            values.DecimalThousandSeparator.selectedValue[lang] = {
                                languageId : lang
                            };
                        }
                        values.DecimalThousandSeparator.selectedValue[lang].decimal = (this.allowDecimalSeparator) ? this.languageObj[lang].decimal : this.languageObj[lang].thousand == '.' ? ',' : (this.languageObj[lang].thousand == "" && this.languageObj['Default'].thousand) == '.'?',' : '.';
                        values.DecimalThousandSeparator.selectedValue[lang].thousand = this.languageObj[lang].thousand == 'SPACE' ? ' ' : this.languageObj[lang].thousand;
                    }

                    LanguageModalInstance.close(this.languageObj);
                };

                /**
                 * @brief      Close language dialog
                 *
                 * @return     NULL
                 */
                this.cancel = function () {
                    // LanguageModalInstance.dismiss('cancel');
                    LanguageModalInstance.close(false);
                };
            }
        });

    }

    getSelectedControlFieldName() {
        let properties = this.getSelectedItemProperties();
        return properties && properties.Basic && properties.Basic['Field Name'] && properties.Basic['Field Name'].selectedValue;
    }

    getProperties(fieldName) {
        let self = this;
        if(!fieldName) {
            return;
        }
        let controls = self.Util.getAllControls();
        let properties;
        controls.some((control) => {
            if(control.properties && control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue == fieldName) {
                properties = control.properties;
                return true;
            }
        });
        return properties;
    }

    /**
     * @brief      Gets the selected item properties.
     *
     * @return     The selected item properties.
     */
    getSelectedItemProperties() {
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
        let properties = (selected.length == 1) ? selected[0].properties : {};
        return properties;
    }

    getInitialColor(){
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
       
        if(selected && selected.length == 1){
            this.fieldName = selected[0].properties.Basic['Field Name'].selectedValue;
            var ele = angular.element('.canvas').find(`[data-fieldname="`+ this.fieldName +`"]`).find('.eng-selected-item');
            this.multiCellObject = [];

            if(ele.length){
                for(var i=0; i< ele.length; i++ ){
                    var col = ele[i].cellIndex;
                    var row = parseInt(ele[i].id.replace('-'+col, ''));
                    var dataObj;

                    if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data"){ //header
                        dataObj = selected[0].header_data[row][col];
                    }
                    else if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data"){ //footer
                        dataObj = selected[0].footer_data[row][col];
                    }
                    else if (selected[0].data){ //data
                        if(selected[0].type == "Layout")
                            dataObj = selected[0].data[col];
                        else
                            dataObj = selected[0].data[row][col];
                    }

                    if(dataObj.style && dataObj.style['background-color'])
                        this.cellColor = dataObj.style['background-color'];
                    else 
                        this.cellColor = 'rgba(255, 255, 255, 0)'; //'transparent'

                    this.multiCellObject.push({"cellRow": row, "cellCol": col, "background-color": this.cellColor});
                }
                
            }
            else this.cellColor = 'rgba(255, 255, 255, 0)'; //'transparent'
            this.onPropValueChanged();
        }
    }

    setBackgroundColor() {
        if(this.fieldName){
            var selected = this.Util.getControlByFieldName(this.fieldName);
            let ele = angular.element('.canvas').find(`[data-fieldname="`+ this.fieldName +`"]`).find('.eng-selected-item');
            
                if(ele.length && this.cellColor){
                    for(var i=0; i< ele.length; i++ ){
                        var col = ele[i].cellIndex;
                        var row = parseInt(ele[i].id.replace('-'+col, ''));
                        var dataObj;
    
                        if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data"){ //header
                            dataObj = selected.header_data[row][col];
                        }
                        else if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data"){ //footer
                            dataObj = selected.footer_data[row][col];
                        }
                        else if (selected.data){ //data
                            if(selected.type == "Layout")
                                dataObj = selected.data[col];
                            else
                                dataObj = selected.data[row][col];
                        }
                        
                        if(!dataObj.style)
                        dataObj.style = {};
    
                        if(this.$window.multiCellSelected){
                            dataObj.style['background-color'] = this.multiCellObject[i]["background-color"];
                            this.cellColor = this.multiCellObject[i]["background-color"];
                        }else{
                            dataObj.style['background-color'] = this.cellColor;
                        }
                        
                    }
                    
                }
            
            if (this.$window.multiCellSelected)
            this.$window.multiCellSelected = false;
        }
        
    }

    removeCellColor(){
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
        
        if(selected && selected.length == 1){
            this.fieldName = selected[0].properties.Basic['Field Name'].selectedValue;
            let properties = selected[0].properties;
            let ele = angular.element('.canvas').find(`[data-fieldname="`+ properties.Basic['Field Name'].selectedValue +`"]`).find('.eng-selected-item');
    
                if(ele.length){
    
                    for(var i=0; i< ele.length; i++ ){
                        var col = ele[i].cellIndex;
                        var row = parseInt(ele[i].id.replace('-'+col, ''));
                        var dataObj;
    
                        if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data"){ //header
                            dataObj = selected[0].header_data[row][col];
                        }
                        else if(ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data"){ //footer
                            dataObj = selected[0].footer_data[row][col];
                        }
                        else if (selected[0].data){ //data
                            if(selected[0].type == "Layout")
                                dataObj = selected[0].data[col];
                            else
                                dataObj = selected[0].data[row][col];
                        }
    
                        if(dataObj.style && dataObj.style['background-color'])
                            dataObj.style['background-color'] = 'rgba(255, 255, 255, 0)';
                        
                    }
                }
        }
    }

    /**
     * @brief      Gets the selected item.
     *
     * @return     The selected item.
     */
    getSelectedItem() {
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
        if (selected[0] && selected[0].type == "Button" || selected[0] && selected[0].type == "SiteLocationButton") {
            delete selected[0].properties.Margin;
        }
        return (selected.length == 1) ? selected[0] : {};
    }

    getSelectedItemCell() {
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
        if(selected.length && selected.length == 1){
            let properties = selected[0].properties;
            let ele = angular.element('.canvas').find(`[data-fieldname="`+ properties.Basic['Field Name'].selectedValue +`"]`).find('.eng-selected-item');
            
            if(ele.length)
                return true;
            else return false;
        }
        else return false;
    }

    getSelectedButtonProperties(values) {
        if(this.config.for == "Meta-Data" || !values.Name) {
            return true;
        }

        let selectedItemType = this.getSelectedItem().type;
        if (selectedItemType == "Line" || selectedItemType == "Image" || selectedItemType == "Label") {
            return true;
        }

        if(this.basicSelected){
            return this.basicFields.indexOf(values.Name.selectedValue) == -1;
        }

        return this.advancedFields.indexOf(values.Name.selectedValue) == -1;
    }
    
    isDivhide() {
        if(this.config.for == "Meta-Data") {
            return true;
        }

        let selectedItemType = this.getSelectedItem().type;
        return selectedItemType == "Line" || selectedItemType == "Image" || selectedItemType == "Label";
    }

    /**
     * Add option for control (Radio, checkbox).
     *
     * @param {any} index
     * @param {any} item
     * @param {any} list
     *
     * @memberof PropertyboxComponent
     */
    addIntoList(index, item, list) {
        let lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }))
        let copiedItem = angular.copy(item);
        for (var i in copiedItem) {
            if (copiedItem[i].name) {
                copiedItem[i].name = "";
            }
            if (copiedItem[i].relation) {
                copiedItem[i].relation = {};
            }
        }
        let arrayOfValues = [];
        let arrayOfLabels = [];
        for (var j = list.length - 1; j >= 0; j--) {
            arrayOfValues.push(list[j].Value.name)
            arrayOfLabels.push(list[j].Label.name)
        }
        if (this.Util.hasDuplicates(arrayOfValues)||this.Util.hasDuplicates(arrayOfLabels)) {
            let msg = this.$translate.instant('duplicate.value.found')
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        }
        copiedItem['id'] = lastId + 1;
        list.splice((index + 1), 0, copiedItem);
        if(typeof this.updateRows === "function") {
            this.updateRows();
        }
    }

    removeDefault(list) {
        for (var i in list) {
            list[i].Default.name = false;
        }
        this.updateRows();
    }

    /**
     *  Remove option for control (Radio, checkbox).
     *
     * @param {any} index
     * @param {any} list
     *
     * @memberof PropertyboxComponent
     */
    removeFromList(index, list) {
        list.splice(index, 1);
        if(typeof this.updateRows === "function") {
            this.updateRows();
        }
    }

     /** 
     * @description Update reference control table list and optionlist when original control static data updated.
     */
    updateReferenceControl(list) {
        const selectedItem = this.getSelectedItem();
        const controls = this.Util.getControlsByDataFieldName(selectedItem.properties.Basic['Data Field Name'].selectedValue);
        if (controls.length > 1) {
            controls.forEach(element => {
                if (element['uid'] != selectedItem['uid']) {
                    element['properties']['Data Source'].table.list = list && list['list'];
                }
            });
        }
    }

    /**
     * Update layout in designer after change in property.
     *
     *
     * @memberof PropertyboxComponent
     */
    updateColumns() {
        let selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
        if (selectedItems.length == 1) {
            let localObj = selectedItems[0],
                columns = localObj.properties.Display.Columns.selectedValue.split('/')[1],
                existingColumn = localObj.data.length,
                columnAdded;

            if (columns > existingColumn) {
                columnAdded = columns - existingColumn;
                for (var i = 0; i < columnAdded; ++i) {
                    localObj.data.push({ elems: [[]] });
                }
            }

            if (columns < existingColumn) {
                localObj.data.length = columns;
            }

        }
    }

    /**
     * Update table in designer after change in property.(Rows, Columns)
     *
     *
     * @memberof PropertyboxComponent
     */
    updateTable() {

        //setTimeout(() => {

        let selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
        if (selectedItems.length == 1) {
            let localObj = selectedItems[0];
            let rows = localObj.properties.Display.Rows.selectedValue;
            let columns = localObj.properties.Display.Columns.selectedValue;

            if (!rows || !columns)
                return;

            let existingRow = localObj.data.length,
                existingColumn = localObj.data[0].length,
                rowAdded,
                columnAdded;

            localObj.ids = []; // Deselect cells when udpate rows/columns
            localObj.reset = true;

            // Increase Rows
            if (rows > existingRow) {
                rowAdded = rows - existingRow;
                for (var i = 0; i < rowAdded; ++i) {
                    localObj.data.push([]);
                    for (var j = 0; j < columns; ++j) {
                        localObj.data[existingRow + i].push({ elems: [[]] });
                    }
                }
            }
            // Increase Columns
            if (columns > existingColumn) {
                columnAdded = columns - existingColumn;
                for (var i = 0; i < columnAdded; ++i) {
                    for (var j = 0; j < rows; ++j) {
                        localObj.data[j].push({ elems: [[]] });
                    }
                }
            }
            // Decrease Rows
            if (rows < existingRow) {
                localObj.data.length = rows;
            }
            // Decrease Columns
            if (columns < existingColumn) {
                for (var i = 0; i < rows; ++i) {
                    localObj.data[i].length = columns;
                }

            }
        }
        //}, 1000);
    }

    /**
     * Update/Reset Repeating table's columns properties
     *
     * @memberof PropertyboxComponent
     */
    updateRepeatingTable() {
        let selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
        if (selectedItems.length == 1) {
            let localObj = selectedItems[0],
                columns = localObj.properties.Basic.Columns.selectedValue,
                existingColumn = localObj.data[0].length,
                columnAdded;

            if (!columns)
                return;

            if (columns > existingColumn) {
                columnAdded = columns - existingColumn;
                for (var i = 0; i < columnAdded; ++i) {
                    localObj.data[0].push({ elems: [[]] });
                    localObj.header_data[0].push({ elems: [[]] });
                    localObj.footer_data[0].push({ elems: [[]] });
                }
            }

            if (columns < existingColumn) {
                localObj.data[0].length = columns;
                localObj.header_data[0].length = columns;
                localObj.footer_data[0].length = columns;
            }

        }
    }

    /**
     * Update/reset Repeating table Header and footer properties
     *
     * @memberof PropertyboxComponent
     */
    updateHeaderAndFooter() {
        let selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
        if (selectedItems.length == 1) {
            let localObj = selectedItems[0];
            let columns = localObj.properties.Basic.Columns.selectedValue;
            let headerIncluded = localObj.properties.Basic.Include_Header.selectedValue;
            let footerIncluded = localObj.properties.Basic.Include_Footer.selectedValue;

            if (!headerIncluded) {
                localObj.header_data = [[]];
            }

            if (!footerIncluded) {
                localObj.footer_data = [[]];
            }

            for (var j = 0; j < columns; ++j) {
                !headerIncluded && localObj.header_data[0].push({ elems: [[]] });
                !footerIncluded && localObj.footer_data[0].push({ elems: [[]] });
            }
        }
    }

    /**
     * Validate input type="number"
     *
     * @param {any} $event
     * @param {any} value
     * @memberof PropertyboxComponent
     */
    validPattern($event, value) {
        let paddingAttribute=["top","bottom","left","right"];
        if (paddingAttribute.indexOf(value.name) > -1) {
            var inputValue: any = isNaN(parseFloat($event.target.value)) ? '0' : parseFloat($event.target.value);

            if (parseFloat(inputValue) < parseFloat(value.min) || parseFloat(inputValue) > parseFloat(value.max)) {
                inputValue = value.min;
                this.ngNotification.error({
                    message: `Please enter a valid number between ${value.min} to ${value.max}.`,
                    positionX: 'center',
                    replaceMessage: true
                });
            }

            value.selectedValue = inputValue;
            $event.target.value = inputValue;

        } else if (['char.limit', 'Columns','min','max','value','thumbnail.width','thumbnail.height'].indexOf(value.name) > -1) {
            var currentControl = this.getSelectedItem();
            var inputValue = isNaN(parseInt($event.target.value)) ? '0' : $event.target.value;
            if (parseInt(inputValue) < parseInt(value.min) || parseInt(inputValue) > parseInt(value.max)) {
                var msg = 'Please enter a valid number between '+ value.min +' to ' + value.max + '.';
                if (currentControl && currentControl.type == 'Rich-Text-Box') {
                    value.selectedValue = isNaN(value.default) ? 3000 : value.default;
                    $event.target.value = isNaN(value.default) ? 3000 : value.default;
                    msg = 'Maximum 5000 Characters allowed!';
                } else {
                    value.selectedValue = isNaN(value.default) ? 20 : value.default;
                    $event.target.value = isNaN(value.default) ? 20 : value.default;
                }
                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            } else {
                value.selectedValue = (parseInt(inputValue) != 0 ? parseInt(inputValue) : (value.default === undefined) ? 20 : value.default);
            }
        } else if(['height','width'].indexOf(value.name) > -1) {
            var inputValue = isNaN(parseInt($event.target.value)) ? value.min : $event.target.value;
            if (parseInt(inputValue) < parseInt(value.min) || parseInt(inputValue) > parseInt(value.max)) {
                value.selectedValue = value.min;
                $event.target.value = value.min;
                var msg = 'Please enter a valid number between '+ value.min+' to ' + value.max + '.';
                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            } else {
                value.selectedValue = (parseInt(inputValue) != 0 ? parseInt(inputValue) : value.min);
            }
        }
    }

    updateAllReadonlyControlEventsProperty(eventDetail) {
        if(!eventDetail) {
            return
        }
        let totalItems = this.Util.getAllControls();
        let selectedItem = this.getSelectedItem();
        let filtered = _.filter(totalItems, { uid: selectedItem.uid });
        filtered.forEach(control => {
            if(control.properties && control.properties.Events) {
                for(let event in control.properties.Events) {
                    let eDetail = control.properties.Events[event];
                    if(eDetail.disable && (eDetail.name == eventDetail.name)) {
                        eDetail.selectedValueReadonly = eventDetail.selectedValue;
                    }
                }
            }
        });
    }

    /**
     * Validate field name on input blur event (Only for Field Name property)
     * Replace field name in Globle and Event code editor script where user had used this field name
     *
     * @param {any} value - New value of field name
     * @param {any} prevValue - Prev value of field name
     * @memberof PropertyboxComponent
     */
    restrictChar(value, prevValue) {
        if(value == prevValue) {
            return;
        }

        var validText = this.Util.isValidXMLTagName(value);
        var isValid = this.Util.isValidString(value);
        if(!isValid){
            let selectedItem = this.getSelectedItem();
            var msg = 'Field name must conform to the following guidelines:<br>-	Field name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Field name cannot contain more than two undescore  (_) continuously.<br>-	Field name cannot contain spaces or start with system reserved words like XML or xml or Xml script, window<br>';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            selectedItem.properties.Basic['Field Name'].selectedValue = prevValue;
            return;
        } else if (validText == false) {
            var msg = 'Field name must conform to the following guidelines:<br>-	Field name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Field name cannot contain more than two undescore  (_) continuously.<br>-	Field name cannot contain spaces or start with system reserved words like XML or xml or Xml<br>';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
        } else if (value && (value.startsWith("DS_") || value.startsWith("DSI_"))) {
            var msg = 'Field name cannot start with "DS_" or "DSI_" as they are reserved for system fields. Kindly update the field name to continue.';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
        } else {
            let selectedItem = this.getSelectedItem();
            let totalItems = this.Util.getAllControls();
            let filtered = _.filter(totalItems, { uid: selectedItem.uid });
            let filterReadOnlyControls = filtered.filter(function (val) {
                return val.copiedFrom != undefined;
            });
            selectedItem.properties.Basic['Field Name'].prevSelectedValue = value;
            let filterCalculatedValues = "";

            for (let i = 0; i < filterReadOnlyControls.length; i++) {
                filterCalculatedValues = filterReadOnlyControls[i].copiedFrom;
                _.set(filterReadOnlyControls[i], "properties.Basic['Field Name'].selectedValue", value);
                _.set(filterReadOnlyControls[i], "properties.Basic['Field Name'].prevSelectedValue", value);
                filterReadOnlyControls[i].copiedFrom && (filterReadOnlyControls[i].copiedFrom = value);
            }

            // initialize the filterCalculatedValues with the previous value, if it is empty
             if(!filterCalculatedValues) {
                filterCalculatedValues = prevValue;
            }

            let filterCalculatedControls = _.filter(totalItems, { pasteAsCalculatedFrom: filterCalculatedValues });
            if(filterCalculatedControls.length && !selectedItem.hasOwnProperty('pasteAsCalculatedFrom')) {
                this.Util.updateCalculatedControls(filterCalculatedControls, selectedItem, value, 'FieldName');
            }

            this.Util.replaceFieldNameInCodeEditor(totalItems, prevValue, value);
        }
    };
    
    /**
     * Validate data field name on input blur event (Only for Data Field Name property)
     * Replace data field name in Globle and Event code editor script where user had used this field name
     *
     * @param {any} value - New value of data field name
     * @param {any} prevValue - Prev value of data field name
     * @memberof PropertyboxComponent
     */
    restrictCharInDataFieldName(value, prevValue, excludeDSValidation = false) {
        let self = this;
        if( typeof value == 'object' ) {
            prevValue = value['Data Field Name'].prevSelectedValue;
            value = value['Data Field Name'].selectedValue;
        }
        
        if(value == prevValue) {
            return;
        }

        var validText = self.Util.isValidXMLTagName(value);
        if (validText == false) {
            var msg = 'Data Field Name must conform to the following guidelines:<br>-	Data Field Name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Data field name cannot contain more than two undescore  (_) continuously.<br>-	Data Field name cannot contain spaces or start with system reserved words like XML or xml or Xml<br>';
            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        }
        if (!excludeDSValidation && value && (value.startsWith("DS_") || value.startsWith("DSI_"))) {
            var msg = 'Data Field Name cannot start with "DS_" or "DSI_" as they are reserved for system fields. Kindly update the field name to continue.';
            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        }

        let selectedItem = self.getSelectedItem();
        let totalItems = self.Util.getAllControls();

        let notAllowedControlTypes = [];
        totalItems.forEach((item) => {
            if(selectedItem.type != item.type) {
                let dataFieldName = item.properties.Basic && item.properties.Basic['Data Field Name'] && item.properties.Basic['Data Field Name'].selectedValue;
                if(dataFieldName && value == dataFieldName && (self.typeWiseDataFieldNameAllowed[selectedItem.type].indexOf(item.type) == -1)) {
                    notAllowedControlTypes.push(item.type);
                }
            }
        });
        if(notAllowedControlTypes.length) {
            let dataFieldNameTypeError = `Please set a Data Field Name which is not used for another controls or use same Data Field Name which is used for ${self.typeWiseDataFieldNameAllowed[selectedItem.type].join(', ')} control.`;
            self.ngNotification.error({ message: dataFieldNameTypeError, positionX: 'center', replaceMessage: true });
            _.set(selectedItem, "properties.Basic['Data Field Name'].selectedValue", prevValue);
            return;
        }
        
        let filtered = _.filter(totalItems, { uid: selectedItem.uid });
        for (let i = 0; i < filtered.length; i++) {
            if(filtered[i].properties && filtered[i].properties.Basic && filtered[i].properties.Basic['Data Field Name']) {
                _.set(filtered[i], "properties.Basic['Data Field Name'].selectedValue", value);
                _.set(filtered[i], "properties.Basic['Data Field Name'].prevSelectedValue", value);
            }
        }

        //Rename data field in FX value if same data field name is used
        let regex = /(^\{\{.*?\}\}$)/;
        totalItems.forEach((control) => {
            let controlValue = _.get(control, 'properties.Basic.Value.selectedValue', '');
            if(typeof(controlValue) == 'boolean') {
                if(controlValue && (prevValue == controlValue)) {
                    _.set(control, 'properties.Basic.Value.selectedValue', '{{' + value + '}}');
                    self.updateDSField(control.properties.Basic);
                }
            } else {
                if (controlValue.match && controlValue.match(regex)) {
                    let val = controlValue.replace('{{', '').replace('}}', '');
                    if(val && (prevValue == val)) {
                        _.set(control, 'properties.Basic.Value.selectedValue', '{{' + value + '}}');
                        self.updateDSField(control.properties.Basic);
                    }
                }
            }
            
        });

        const calculatedControlFieldName = _.get(selectedItem, 'properties.Basic["Field Name"].selectedValue');
        let calculatedControls = _.filter(totalItems, {pasteAsCalculatedFrom: calculatedControlFieldName});
        if(calculatedControls.length) {
            this.Util.updateCalculatedControls(calculatedControls, selectedItem, value, 'DataFieldName');
        }


        this.Util.replaceDataFieldNameInCodeEditor(totalItems, prevValue, value);
    };

    noop = angular.noop;

    /**
     * Open data source selection popup for dropdown
     *
     * @param {any} sourceType
     * @param {any} properties
     * @memberof PropertyboxComponent
     */
    editDataSource(sourceType, properties) {
        let self = this;
        let selectedItem = self.getSelectedItem();
        if (selectedItem.type == "Dropdown" || selectedItem.type == "MultiDropdown") {
            self.editDropDownSource(sourceType, properties);
        }
        if (selectedItem.type == "Image") {
            self.editImageSource(sourceType, properties);
        }
    }

    sourceChanged(sourceType, properties) {
        let self = this;
        let selectedItem = self.getSelectedItem();
        if (selectedItem.type == "Image") {
            _.set(properties, 'Url.selectedValue', '');
        }
    }

    editImageSource(sourceType, properties) {
        let self = this;
        let modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'image.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            windowClass: 'image-modal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                let _this = this;
                let selectedItem = self.getSelectedItemProperties();

                _this.image = '';
                _this.source = _.get(selectedItem, "Basic.Url.selectedValue", '');
                _this.sourceType = sourceType;
                if ((_this.sourceType == 0 && _this.source.indexOf('data:') == 0) || (_this.sourceType == 1 && _this.source.indexOf('http') == 0)) {
                    _this.source = '';
                }

                _this.properties = angular.copy(properties);

                _this.save = function (url) {
                    _.set(properties, 'Url.selectedValue', url || '');
                    this.cancel();
                };
                _this.cancel = function () {
                    // modalInstance.dismiss('cancel');
                    modalInstance.close(false);
                };
            }
        });
    }

    editDropDownSource(sourceType, properties) {
        let self = this;
        let modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'dataSource.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                let _this = this;
                this.sourceType = sourceType;
                this.urls = [];
                let selectedItem = self.getSelectedItemProperties();
                this.sourceType == 3 && (this.multipleSelectedValue = (selectedItem.Basic['Multi-Select'] && selectedItem.Basic['Multi-Select'].selectedValue) || selectedItem['Basic'].ControlType == 'MultiDropdown');
                this.properties = JSON.parse(JSON.stringify(properties));
                this.sourceType == 1 && (this.urls = self.Util.getAvailableDS());
                this.sourceType == 4 && (this.urls = self.Util.getFixedFields(this.properties.fixedFieldUrl.singleValue));
                // this.sourceType == 5 && (this.urls = self.Util.getCustomAttributes());
                this.list = (this.properties.table || {}).list;
                this.parameterList = (this.properties.Parameters || {}).list;
                this.designType=self.config.for;
                let setDropdownOptionsForHierarchy = function () {
                    let selectedValue = _this.properties.customAttr.selectedValue;
                    //Filtering out ONLY the Hierarchy containing Attribute Sets from the response data
                    const projectCustomAttributeSets = JSON.parse(JSON.stringify(self.$rootScope.ProjectCustomAttributeSet));
                    _this.firstDropdownOptions.length = 0;
                    if (projectCustomAttributeSets && projectCustomAttributeSets.length && selectedValue) {
                        for (let i = 0; i < projectCustomAttributeSets.length; i++) {
                            const attrSet = projectCustomAttributeSets[i];
                            if (attrSet.hierarchyAttributes) {
                                let hasParentAsAttr = false;
                                for (let j = 0; j < attrSet.hierarchyAttributes.length; j++) {
                                    const element = attrSet.hierarchyAttributes[j];
                                    if (element.parentAttributeName == selectedValue) {
                                        hasParentAsAttr = true;
                                        break;
                                    }
                                }
                                hasParentAsAttr && _this.firstDropdownOptions.push({
                                    attributeName: attrSet.attributeSetName,
                                    attributeSetId: attrSet.attributeSetId,
                                    hierarchyAttributes: attrSet.hierarchyAttributes
                                });
                            }
                        }
                    }
                    // Dropdown options for Child Dropdown
                    if (!_this.firstDropdownOptions.length) {
                        _this.secondDropdownOptions.length = 0;
                    }
                    else {
                        let fielNameArr: any = [];
                        for (let k = 0; k < _this.allControls.length; k++) {
                            let controls = _this.allControls[k];
                            if (controls.viewName == self.selectedView.view.viewName && controls.copiedFrom == undefined && controls.selected == true && controls.properties["Data Source"].Source.selectedValue == 5 && controls.parent == 'repeating-table') {
                                _this.allControlsgGot = [];
                                // this will check the controls with same level of RT need to be map.
                                for (let x = 0; x < _this.allControlsRT.length; x++) {
                                    if (_this.allControlsRT[x].parentFieldName == controls.parentFieldName && controls.parent == 'repeating-table') {
                                        _this.allControlsgGot.push(_this.allControlsRT[x]);
                                    }
                                    // this will check the controls with nested 1 level deep of RT need to be map.
                                    for (let f = 0; f < _this.gotAllControls.length; f++) {
                                        if (_this.gotAllControls[f].properties.Basic && _this.gotAllControls[f].properties.Basic['Data Field Name'] != undefined && _this.gotAllControls[f].properties.Basic['Data Field Name'].selectedValue == _this.allControlsRT[x].parentFieldName && _this.gotAllControls[f].parentFieldName == controls.parentFieldName) {
                                            _this.allControlsgGot.push(_this.allControlsRT[x]);
                                        }
                                    }
                                }
                                break;
                            } else _this.allControlsgGot = _this.allControls.filter(control => control.viewName === self.selectedView.view.viewName && !control.copiedFrom && control.properties["Data Source"].Source.selectedValue == 5);
                        }
                        _this.optionNumber = [];
                        for (let j = 0; j < _this.firstDropdownOptions.length; j++) {
                            _this.elements = [];
                            for (let l = 0; l < _this.firstDropdownOptions[j].hierarchyAttributes.length; l++) {
                                if (_this.firstDropdownOptions[j].hierarchyAttributes[l].parentAttributeName == _this.properties.customAttr.selectedValue) {
                                    for (let k = 0; k < _this.allControlsgGot.length; k++) {
                                        let control = _this.allControlsgGot[k];
                                        if (control.selected != true && control.properties["Data Source"].Source.selectedValue == 5) {
                                            if (_this.firstDropdownOptions[j].hierarchyAttributes[l].childAttributeName == control.properties["Data Source"].customAttr.selectedValue) {
                                                _this.elements.push(JSON.stringify({
                                                    controlFieldName: control.properties.Basic["Field Name"].selectedValue,
                                                    attributeName: _this.firstDropdownOptions[j].hierarchyAttributes[l].childAttributeName
                                                }));
                                                fielNameArr.push(control.properties.Basic["Field Name"].selectedValue);
                                            }
                                        }
                                    }
                                }
                            }
                            _this.optionNumber[j] = _this.firstDropdownOptions[j].attributeSetId;
                            _this.secondDropdownOptions[j] = _this.elements;
                        }
                    }
                    if (!_this.firstDropdownOptions && !_this.secondDropdownOptions.length) {
                        _this.hierarchyData.length = 0;
                        _this.hierarchyData.push({
                            attributeSetData: '',
                            childDropdown: '',
                            parentAttributeName: ''
                        });
                    }
                };

                let updateCustomAttr = function (oldAttr, columnList) {
                    if (Object.keys(oldAttr.name).length != 0) {
                        let findNewAttrID = columnList.filter(e => e.id != oldAttr.name.id && e.colDisplayName == oldAttr.name.colDisplayName);
                        findNewAttrID && findNewAttrID[0] && (oldAttr.name.id = findNewAttrID[0].id);
                        findNewAttrID && findNewAttrID[0] && (oldAttr.value = findNewAttrID[0].id);
                    }
                }

                if (this.sourceType == 5) {
                    this.urls = self.Util.getCustomAttributes();
                    this.gotAllControls = self.Util.getAllControls();
                    this.allControls = self.Util.getControlsByType(['Dropdown', 'MultiDropdown']);
                    this.allControlsRT =  [];
                    this.allControlsNew = [];
                    for (let i = 0; i < this.allControls.length; i++) {
                        if(this.allControls[i].parent == 'repeating-table'){
                            _this.allControlsRT.push(this.allControls[i]);
                        } else {
                            _this.allControlsNew.push(this.allControls[i]);
                        }
                    }
                    this.hierarchyData = this.properties.customAttr.hierarchyData;
                    
                    this.firstDropdownOptions = [];
                    this.secondDropdownOptions = [];    
                    if (this.hierarchyData && this.hierarchyData.length < 1) {
                        this.hierarchyData.push({
                            attributeSetData: '',
                            childDropdown: '',
                            parentAttributeName:''
                        });
                    }
                    setDropdownOptionsForHierarchy();
                }

                if (this.sourceType == 6) {
                    this.columnList = self.Util.docColData;
                    this.columnList = this.columnList.filter(e => e.colDisplayName != 'Doc Ref');
                    if (this.list.length > 1) {
                        for (let item of this.list) {
                            item.Value.name.isCustomAttributeColumn == true && updateCustomAttr(item.Value, this.columnList);
                        }
                    }
                }
                if (this.sourceType == 7) {
                    this.columnList = self.Util.appColData;
                    this.columnList = this.columnList.filter(e => e.colDisplayName != 'ID');
                }
                if(this.sourceType == 8) {
                    if(selectedItem.Basic['Assoc Type'].selectedValue == 'Files') {
                        this.columnList = self.Util.docColData;
                        this.columnList = this.columnList.filter(e => e.colDisplayName != 'Doc Ref');
                        if (this.list.length > 1) {
                            for (let item of this.list) {
                                item.Value.name.isCustomAttributeColumn == true && updateCustomAttr(item.Value, this.columnList);
                            }
                        }
                    } else if(selectedItem.Basic['Assoc Type'].selectedValue == 'Apps') {
                        this.columnList = self.Util.appColData;
                        this.columnList = this.columnList.filter(e => e.colDisplayName != 'ID');
                    }
                }

                this.getSelectedDropdownOption = function (item, selectedOption) {
                    if(selectedOption && selectedOption != "") {
                        let index = this.columnList.findIndex(ele => ele.id == selectedOption);
                        item.name = this.columnList[index];
                    } else if (selectedOption == "") {
                        item.name = selectedOption;
                    }
                }
               
                this.addAssocRowInList = function (index, item, list) {
                    let lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }))
                    let copiedItem = angular.copy(item);
                    for (let i in copiedItem) {
                        if (copiedItem[i].name && copiedItem[i].name != 'sorting') {
                            copiedItem[i].name = "";
                        }
                        if (copiedItem[i].selectedValue) {
                            copiedItem[i].selectedValue = "";
                        }
                    }
                    let arrayOfValues = [];
                    for (let j = list.length - 1; j >= 0; j--) {
                        let uniqVal = list[j].Value.name.fieldName ? list[j].Value.name.fieldName : list[j].Value.name;
                        list[j].Value && arrayOfValues.push(uniqVal);
                    }
                    if (this.Util.hasDuplicates(arrayOfValues)) {
                        let msg = this.$translate.instant('duplicate.value.found')
                        this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                        return;
                    }
                    copiedItem['id'] = lastId + 1;
                    list.splice((index + 1), 0, copiedItem);
                    if (typeof this.updateRows === "function") {
                        this.updateRows();
                    }
                }
                this.selectSortOrder = function (item, selectedVal) {
                    for (const ele of this.list) {
                        if (ele.Sorting && ele.Sorting.selectedValue && ele.Sorting.selectedValue != '') {
                            ele.Sorting.selectedValue = '';
                        }
                    }
                    item.selectedValue = selectedVal;
                }

                this.selectDefaultSortOrd = function (item, selectedVal) {
                    if (item.DefaultRd) {
                        return;
                    } else {
                        item.selectedValue = selectedVal;
                        item['DefaultRd'] = true;
                    }
                }

                if (this.properties.fixedFieldUrl && typeof this.properties.fixedFieldUrl.selectedValue != 'string') {
                    let field = this.urls.filter(function (value) {
                        return value.value == _this.properties.fixedFieldUrl.selectedValue.value;
                    });
                    if (field.length) {
                        this.properties.fixedFieldUrl.selectedValue.key = field[0].key;
                    }
                }

                this.clearAttributeSet = function () {
                    this.properties.customAttr.selectedValue = '';
                    this.firstDropdownOptions = [];
                    this.secondDropdownOptions = [];
                    if(this.hierarchyData && this.properties.customAttr.hierarchyApplied){
                        this.hierarchyData.length = 0;
                        this.hierarchyData.push({
                            attributeSetData: '',
                            childDropdown:'',
                            parentAttributeName:''
                        }); 
                    }
                }

                this.onChangeFunctionAttributeName = function () {
                    angular.isObject(this.properties.customAttr.selectedValue) && (this.properties.customAttr.selectedValue = this.properties.customAttr.selectedValue.value);
                    let selectedValue = this.properties.customAttr.selectedValue;
                    if (!selectedValue) {
                        self.ngNotification.error({ message: 'Custom Attribute name missing.', positionX: 'center', replaceMessage: true });
                        if (this.hierarchyData && this.properties.customAttr.hierarchyApplied) {
                            this.firstDropdownOptions = [];
                            this.secondDropdownOptions = [];
                            this.hierarchyData.length = 0;
                            this.hierarchyData.push({
                                attributeSetData: '',
                                childDropdown: '',
                                parentAttributeName:''
                            });
                        }
                        return;
                    }
                    if (selectedValue.indexOf('"') != -1) {
                        self.ngNotification.error({ message: 'Custom Attribute name should not contain ".', positionX: 'center', replaceMessage: true });
                        return;
                    }
                    if (this.sourceType == 5) { setDropdownOptionsForHierarchy(); }
                }

                this.save = function () {
                    if (this.sourceType == 3) {
                        let arrOfValues = [];
                        let arrOfLabels = [];
                        
                        for (var j = this.properties.table.list.length - 1; j>= 0; j--) {
                            arrOfValues.push(this.properties.table.list[j].Value.name);
                            arrOfLabels.push(this.properties.table.list[j].Label.name);
                        }
                        if(this.Util.hasDuplicates(arrOfValues)||this.Util.hasDuplicates(arrOfLabels)){
                            let msg= self.$translate.instant('duplicate.value.found')
                                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                                return; 
                        }
                        self.updateReferenceControl(this);
                    }
                    if (this.sourceType == 1) {
                        if (!angular.isObject(this.properties.Url.selectedValue)) {
                            self.ngNotification.error({ message: 'Url is missing.', positionX: 'center', replaceMessage: true });
                            return;
                        }
                    }
                    if (this.sourceType == 4) {
                        if (!angular.isObject(this.properties.fixedFieldUrl.selectedValue)) {
                            self.ngNotification.error({ message: 'Url is missing.', positionX: 'center', replaceMessage: true });
                            return;
                        }
                    }
                    if (this.sourceType == 5) {
                        if (!this.properties.customAttr.selectedValue) {
                            self.ngNotification.error({ message: 'Custom Attribute name missing.', positionX: 'center', replaceMessage: true });
                            return;
                        }
                        let selectedValue = angular.isObject(this.properties.customAttr.selectedValue) ? this.properties.customAttr.selectedValue.value : this.properties.customAttr.selectedValue;
                        if (selectedValue.indexOf('"') != -1) {
                            self.ngNotification.error({ message: 'Custom Attribute name should not contain ".', positionX: 'center', replaceMessage: true });
                            return;
                        }
                        if (this.properties.customAttr.hierarchyApplied == true) {
                            for (let j = this.hierarchyData.length - 1; j >= 0; j--) {
                                if (!this.hierarchyData[j].attributeSetData) {
                                    self.ngNotification.error({ message: 'Attribute Set missing.', positionX: 'center', replaceMessage: true });
                                    return;
                                }
                                if (!this.hierarchyData[j].childDropdown) {
                                    self.ngNotification.error({ message: 'Child Attribute missing.', positionX: 'center', replaceMessage: true });
                                    return;
                                }
                                this.hierarchyData[j].parentAttributeName = this.properties.customAttr.selectedValue;
                            }
                        }
                        angular.isObject(this.properties.customAttr.selectedValue) && (this.properties.customAttr.selectedValue = this.properties.customAttr.selectedValue.value);
                    }
                    if (this.sourceType == 6 || this.sourceType == 7 || this.sourceType == 8) {
                        let arrOfValues = [];
                        for (let j = this.properties.table.list.length - 1; j >= 0; j--) {
                            arrOfValues.push(this.properties.table.list[j].Value.name.fieldName);
                            if (this.Util.hasDuplicates(arrOfValues)) {
                                let msg = self.$translate.instant('duplicate.value.found')
                                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                                return;
                            } else if (this.properties.table.list[j].Value.name.fieldName == undefined) {
                                self.ngNotification.error({ message: 'Please select value in every dropdown', positionX: 'center', replaceMessage: true });
                                return;
                            }
                        }
                    }
                    properties.table && (properties.table.list = this.list);
                    properties.Parameters && (properties.Parameters.list = this.parameterList);
                    angular.merge(properties, this.properties);
                    if(this.sourceType == 6 || this.sourceType == 7 || this.sourceType == 8) {
                        try {
                            self.Util.refreshReadOnlyControlsPropeties(self.getSelectedItem().properties.Basic['Field Name'].selectedValue);
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    this.cancel();
                };
                this.cancel = function () {
                    // modalInstance.dismiss('cancel');
                    modalInstance.close(false);
                };
                this.addIntoList = self.addIntoList;
                this.addInList = function(index, list) {
                    list.splice(index, 0, {
                        attributeSetData: '',
                        childDropdown: '',
                        parentAttributeName:'',
                        childAttributeName:''
                    }); 
                };
                this.removeFromListDD = function(index, list) {
                    list.splice(index, 1); 
                };
                this.getDropdowns = function (selectedOption) {
                    if (selectedOption) {
                        for (let k = 0; k < _this.optionNumber.length; k++) {
                            if (_this.optionNumber[k] == selectedOption) {
                                return _this.secondDropdownOptions[k].filter((item, index, arr) => arr.indexOf(item) === index);
                            }
                        }
                    }
                };
                this.ngNotification = self.ngNotification;
                this.Util=self.Util;
                this.$translate=self.$translate;
                this.removeFromList = self.removeFromList;
                this.isObject = angular.isObject;
                this.openDSHelp = self.openDSHelp.bind(self);
                this.resetDefaultForRadio = self.resetDefaultForRadio;
            }
        });
    }

    /**
     * Open Fixedfields value selection popup
     *
     * @param {any} properties
     * @memberof PropertyboxComponent
     */
    existingDataField(properties) {
        let self = this,
        selected = this.Util.returnSelected(this.selectedView.view.controls.A),
        numberSelectedType,numberSelectedTypeUnderRepeatingTbl = false,
        showExistingDS = selected.length && selected[0].parent != 'repeating-table',
        selectedOperator,
        selectedElemType = selected[0].type.toLowerCase(),currentCalQuery,validFormula= true;
        
        if(selectedElemType == "display field"){
            //updating text box value type to number if validate is selected as decimal/integer 
            this.updateValueType();
            numberSelectedType = properties.Type.number;
            let parentnode = properties.parentNode.id;
            this.updateRepeatingTableDSFieldType("",false,parentnode);
            numberSelectedTypeUnderRepeatingTbl = properties.Type.numberUnderRepeatingTable;
            currentCalQuery = properties.formula.html;
        }
        let operatorsAry = ['+','-','*','/','(',')',',','\'','[',']'];
        let modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'existingDataField.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$ctrl',
            windowClass: 'calculate-field-modal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {
                //getting all the textbox fields where validate is set as decimal/integer and Calculated-Value fields
                if(numberSelectedType == true && showExistingDS && selectedElemType == "display field"){
                    properties.Label.isSelected = true;
                    this.numberfields =  self.Util.getNumberFieldNames();
                    properties.Type.number = true;
                }
                //getting all the Calculated-Value fields and textbox fields for same repeating table as of display field, where validate is set as decimal/integer
                else if(numberSelectedTypeUnderRepeatingTbl == true && selectedElemType == "display field"){
                    properties.Label.isSelected = true;
                    let parentnode = properties.parentNode.id;
                    this.numberfields =  self.Util.getNumberFieldNamesunderRepeatingTbl(undefined,undefined,parentnode);
                    properties.Type.number = true;
                }
                this.systemfields = showExistingDS ? self.Util.getDataFieldNames() : [];

                this.systemfields = this.systemfields.concat(self.Util.getFixedFields(true));
                this.getFieldsByGroup = (search,inputfield) => {
                    if(!search) search = "";
                    if(this.properties.DSName.selectedValue == "calculated" || inputfield == 'field') this.fields = this.numberfields;
                    else this.fields = this.systemfields;

                    var filtered = _.filter(angular.copy(this.fields), (n) => {
                        if (_.includes(n.key.toLowerCase(), search.toLowerCase())) {
                            return n
                        }
                    });
                    if(inputfield == 'field'){
                        filtered = filtered.filter(function(el){
                            if((el.parent && el.parent == "outsideRT") || !el.parent) return el;
                        })
                    }
                    var results = _.groupBy(filtered, 'group');

                    results = _.map(results, function (g) {
                        g[0].firstInGroup = true; // the first item in each group
                        return g;
                    });

                    results = _.flatten(results);
                    return results;
                };

                this.properties = angular.copy(properties);
                if(this.properties.DSName.selectedValue != "calculated"){
                    this.Value = this.properties.Value.selectedValue;

                    let regex = /(^\{\{.*?\}\}$)/;
                    if (this.Value && this.Value.match(regex)) {
                        let val = this.Value.replace('{{', '').replace('}}', '');
                        if(this.properties.DSName.selectedValue == "calculated") this.fields = this.numberfields;
                        else this.fields = this.systemfields;
                        let field = this.fields.filter(function (value) {
                            return value.key == val;
                        });
                        field.length && (this.Value = field[0]);
                    }
                    if (!angular.isObject(this.Value)) {
                        this.Value = "";
                    }
                }

                this.save = function () {
                    if(this.properties.DSName.selectedValue != "calculated"){
                        if(properties.formula){
                            this.resetCondition(properties)
                        } 
                        if (angular.isObject(this.Value)) {
                            properties.Value.selectedValue = '{{' + this.Value.key + '}}';
                            properties.DSName && (properties.DSName.selectedValue = this.Value.value);
                            properties.Value.readonly = false;
                            // Removing the pasteAsCalculated control property
                            let selectedItem = self.getSelectedItem();
                            selectedItem.hasOwnProperty('derivedControlType') && delete selectedItem.derivedControlType;
                            selectedItem.hasOwnProperty('derivedFromFieldName') && delete selectedItem.derivedFromFieldName;
                            selectedItem.hasOwnProperty('pasteAsCalculatedFrom') && delete selectedItem.pasteAsCalculatedFrom;
                        } else {
                            properties.DSName && (properties.DSName.selectedValue = '');
                        }
                    }
                    else{
                        if(!this.syncCalcQuery())
                        return;
                        let calculationQuery = this.properties.formula.html;
                        properties.formula.html = calculationQuery;

                        let textboxFieldsAry = calculationQuery.split('<span class="calculateFieldSpan">');
                        textboxFieldsAry = textboxFieldsAry.filter(function(el){
                            if(el != "") return el;
                        });
                        let views = self.views,calFields = [];
                        for (let view in views) {
                            for(let v=0;v<self.Util.getIteams(views[view].controls.A).length;v++){
                                calFields.push(self.Util.getIteams(views[view].controls.A)[v]);
                            }
                        }
                        let showValMsg = false, selField;                        
                        textboxFieldsAry.forEach(field => {
                            field = field.substr(0,field.indexOf("</span>"));
                            if(field.indexOf("sum(") != -1) field = field.substr(4,field.length-5);
                            calFields.forEach(calField =>{
                                if(calField.type == "Textbox"){
                                    if((field == calField.properties.Basic["Field Name"].selectedValue && calField.properties.Basic.Validate.selectedValue != "Integer" && calField.properties.Basic.Validate.selectedValue != "Decimal")){
                                        showValMsg = true;
                                        selField = field;
                                    }
                                }
                            });
                        });
                        if(showValMsg){
                            self.ngNotification.error({ message: "Validate type for "+selField+" is not Integer or Decimal", positionX: 'center', replaceMessage: true });
                            return;
                        }

                        //removing html and keeping only the values from the query
                        calculationQuery = calculationQuery
                                            .replace(/<span class="calculateFieldSpan">/g,' ')
                                            .replace(/<span class="calculateOptSpan">/g,' ')
                                            .replace(/<span class="calculateNumSpan">/g,' ')
                                            .replace(/<span class="calculateBracesSpan">/g,' ')
                                            .replace(/<\/span>/g,' ');
                        
                        let formulaToPrint = calculationQuery;
                        if(calculationQuery.indexOf("math.sum") != -1)
                            calculationQuery = calculationQuery.replace(/math.sum/g,'MATH_SUM_FUN');
                        let splitAry = calculationQuery.split(" "),UidArry = [];
                        for(let i=0;i<splitAry.length;i++){
                            if(!parseFloat(splitAry[i])){
                                let str = angular.element.trim(splitAry[i].replace("sum(","").replace(")","").replace("{","").replace("}",""));
                                 calFields.forEach(calField =>{
                                     if((calField.type == "Textbox" || calField.type == "Display field") && calField.properties.Basic["Field Name"].selectedValue == str){
                                         if(UidArry.indexOf(calField.uid) == -1)
                                         UidArry.push(calField.uid);
                                     }
                                 });
                            }
                        }
                        properties.formula.uids = UidArry;
                        for(let i=0;i<splitAry.length;i++){                            
                           if(splitAry[i] != "" && !parseFloat(splitAry[i]) && operatorsAry.indexOf(splitAry[i]) == -1 && splitAry[i].indexOf("{") != -1 && splitAry[i].indexOf("}") != -1) splitAry[i] = 1;
                        }
                        calculationQuery = splitAry.join("");
                        calculationQuery = calculationQuery.replace(/MATH_SUM_FUN/g,'math.sum');
                        try {
                            if(eval(calculationQuery)){
                                validFormula = true;
                               this.cancel();
                            }
                        } catch (err) {
                            self.ngNotification.error({ message: "Please enter a valid calculation formula", positionX: 'center', replaceMessage: true });
                            validFormula = false;
                            return;
                        }
                        //updating rules lists 
                        if(properties.list && properties.list.listItem.length){
                            this.properties.list.listItem = this.properties.list.listItem.filter(function(item){
                                if(item.field.value != "" || item.id == 0)
                                return item;
                            })
                            properties.list.listItem = this.properties.list.listItem;
                        }

                        //adding all the rules into an array for displaying under properties tab
                        let rules = [];
                        let rulesStr = "";
                        if(this.properties.list){
                            this.properties.list.listItem.forEach(item =>{
                                if(item.field.value != "" && angular.isObject(item.field.value)){
                                    rulesStr = "If " +item.field.value.value + " is " +item.operator.selected;

                                    if(item.target.hidden == false && item.target.disable == false){
                                        rulesStr = rulesStr + " " + item.target.value;
                                    }
                                    if(item.conjuction.hidden == false){
                                        rulesStr = rulesStr + " " + item.conjuction.selected;
                                    }
                                    if(rulesStr != "")
                                    rulesStr = rulesStr +'\n'
                                    rules.push(rulesStr)
                                }
                            });
                            if(formulaToPrint && formulaToPrint != ""){
                                let splitFormulaAry = formulaToPrint.split(" ");
                                for(let f=0;f<splitFormulaAry.length;f++){
                                    if(splitFormulaAry[f] != "" && operatorsAry.indexOf(splitFormulaAry[f]) == -1 && !parseFloat(splitFormulaAry[f])){
                                        splitFormulaAry[f] = splitFormulaAry[f];
                                    }
                                }
                                formulaToPrint = splitFormulaAry.join(" "); 
                                console.log("formulaToPrint: "+formulaToPrint)
                                properties.Value.readonly = true;
                                if(rules.length){
                                    rules[rules.length -1] = rules[rules.length -1].replace("AND",'');
                                    properties.formula.hidden = false;
                                    properties.formula.selectedValue = rules.join("");
                                    properties.formula.rules = rules.join("");
                                }
                                let appendStr = (properties.formula.selectedValue != "") ? "than " : " ";
                                properties.formula.selectedValue = properties.formula.selectedValue + appendStr
                                                                    +properties["Field Name"].selectedValue + " = "
                                                                    +formulaToPrint;
                                properties.DSName.selectedValue = "calculated";
                                if(!this.properties.formula.edit)
                                properties.Value.selectedValue = formulaToPrint;
                                else
                                properties.Value.selectedValue = this.properties.Value.selectedValue;
                            }
                            else if(this.properties.DSName.selectedValue == "calculated" || (this.Value == "" && (this.properties.DSName.selectedValue != "calculated"))){
                                //reseting to default if calculation query removed and saved
                                this.resetCondition(properties)
                            }
                            
                            this.properties.list.listItem[0].addField.value = '';
                            this.properties.list.listItem[0].addSum.disable = true;
                            this.properties.list.listItem[0].addField.disable = true;
                        }   

                    }    
                    this.cancel();
                };
                this.cancel = function () {
                    if(!validFormula) properties.formula.html = currentCalQuery;
                    properties.Label.isSelected = false;
                    // modalInstance.dismiss('cancel');
                    modalInstance.close(false);
                };
                this.isObject = angular.isObject;
                this.openDSHelp = self.openDSHelp.bind(self);
                this.addNewRuleDiv = self.addNewRuleDiv;
                this.removeFromList = self.removeFromList;
                this.resetCondition = self.resetCondition;
                //updating the selected tab
                this.showcurrenttabdiv = function(selectedVal){
                    if(selectedVal == "") this.properties.DSName.selectedValue = "calculated";
                    else this.properties.DSName.selectedValue = "";
                };
                //validation for valid calculation query
                this.checkForOperator = function(optIndex,calculationQuery,bracesIndex,keypressed){
                    let operatorAdded = true;
                    if(calculationQuery.length != optIndex+10 && calculationQuery != ''){
                        operatorAdded = false;
                    }
                    if(bracesIndex != undefined){
                        if((calculationQuery != '' && calculationQuery.length == bracesIndex+42  && calculationQuery.charAt(calculationQuery.length - 8) == "(") || calculationQuery.length == optIndex+10 || calculationQuery == ""){
                            operatorAdded = true;
                        }
                        else{
                            operatorAdded = false;
                        }
                    }
                    else if((calculationQuery == "" && keypressed != ")") || 
                    (calculationQuery != '' && ((calculationQuery.length != optIndex+10 && keypressed == ")" && calculationQuery.indexOf("(") != -1) || 
                    (calculationQuery.length == optIndex+10 && keypressed == "(")   || 
                    (calculationQuery.lastIndexOf('<span class="calculateBracesSpan">')+42 != calculationQuery.length && keypressed == ")") || 
                    (calculationQuery.lastIndexOf('<span class="calculateBracesSpan">')+42 == calculationQuery.length && keypressed == "(")) &&
                    (calculationQuery.indexOf(")") == -1 || keypressed == "(" || (calculationQuery.indexOf("(") != -1 && calculationQuery.indexOf(")") != -1 && calculationQuery.match(/\(/g).length > calculationQuery.match(/\)/g).length)))){
                        operatorAdded = true;
                    }
                    else operatorAdded = false;
                    if(!operatorAdded) self.ngNotification.error({ message: "Please enter an operator!", positionX: 'center', replaceMessage: true });
                    return operatorAdded;
                },
                //entering key pressed values from calculator
                this.num = function(keypressed,keytype){
                    let calculationQuery = this.properties.formula.html;
                    let optIndex = calculationQuery.lastIndexOf('<span class="calculateOptSpan">');
                    let bracesIndex = calculationQuery.lastIndexOf('<span class="calculateBracesSpan">');
                    if(optIndex != -1) optIndex = optIndex + 31;
                    else optIndex == 0;
                    
                    if(keytype && keytype == "field"){
                        if(keypressed.value && keypressed.value != "" && this.checkForOperator(optIndex,calculationQuery,bracesIndex)){
                            let fieldentered = keypressed.value;
                            this.properties.formula.html = calculationQuery + '<span class="calculateFieldSpan">{'+fieldentered+'}</span>';
                            this.properties.list.listItem[0].addField.value = "";
                            this.properties.list.listItem[0].addField.disable = true;
                        }
                        else{
                            return;
                        }
                    }
                    else{
                        if(keytype && keytype == 'operator'){
                            if(calculationQuery == ""){
                                self.ngNotification.error({ message: "First character cannot be an operator!", positionX: 'center', replaceMessage: true });
                                return;
                            }
                            if(calculationQuery.length == bracesIndex+42 && calculationQuery.charAt(calculationQuery.length - 8) == "("){
                                self.ngNotification.error({ message: "Operator not allowed after opening bracket!", positionX: 'center', replaceMessage: true });
                                return;
                            }
                            if(calculationQuery.length == optIndex+10){
                                let charAtIndex = calculationQuery.charAt(optIndex+1);
                                if(operatorsAry.indexOf(charAtIndex) != -1){
                                    this.properties.formula.html = calculationQuery.substr(0, optIndex+1) + keypressed+ calculationQuery.substr(optIndex + 1 + keypressed.length);
                                }
                            }
                            else{
                                this.properties.formula.html = this.properties.formula.html + '<span class="calculateOptSpan"> '+keypressed+' </span>';
                            }
                        }
                        else if(keytype && keytype == 'braces'){
                            if(this.checkForOperator(optIndex,calculationQuery,undefined,keypressed))
                            this.properties.formula.html = this.properties.formula.html + '<span class="calculateBracesSpan">'+keypressed+'</span>';
                        }
                        else{
                            let startSpanIndex = calculationQuery.lastIndexOf('<span class="calculateNumSpan">');                            
                            let tempCalcQuery = calculationQuery.substr(startSpanIndex,calculationQuery.length);
                            let closeSpanIndex = tempCalcQuery.indexOf('</span>');
                            let numIndex = startSpanIndex + closeSpanIndex + 7;
                            if(keypressed == "." && ((tempCalcQuery.indexOf(".") != -1 && tempCalcQuery.match(/\./g).length) || 
                            calculationQuery.length == optIndex+10 || calculationQuery.length == bracesIndex+42 || calculationQuery == "")){
                                self.ngNotification.error({ message: "Please enter valid number!", positionX: 'center', replaceMessage: true });
                                return;
                            }
                            if(numIndex == calculationQuery.length && calculationQuery != ""){
                                let addCharAt = calculationQuery.length - 7;
                                this.properties.formula.html = calculationQuery.substr(0,addCharAt).concat(keypressed)+'</span>';
                            }
                            else{
                                if(this.checkForOperator(optIndex,calculationQuery,bracesIndex))
                                this.properties.formula.html = this.properties.formula.html + '<span class="calculateNumSpan">'+keypressed+'</span>';
                            }
                        }
                    }
                }
                //clearing last key pressed from calculator
                this.clear = function(){
                    let calculationQuery = this.properties.formula.html;
                    let calculateAry = calculationQuery.split("</span>");
                    //removing charecters for numbers added from span
                    let startSpanIndex = calculationQuery.lastIndexOf('<span class="calculateNumSpan">');                            
                    let tempCalcQuery = calculationQuery.substr(startSpanIndex,calculationQuery.length);
                    let closeSpanIndex = tempCalcQuery.indexOf('</span>');
                    let numIndex = startSpanIndex + closeSpanIndex + 7;
                    let removeCharAt = startSpanIndex + closeSpanIndex - 1;
                    if(startSpanIndex+39 != calculationQuery.length && numIndex == calculationQuery.length){
                        calculationQuery = calculationQuery.substr(0, removeCharAt) + calculationQuery.substr(removeCharAt+1);
                        this.properties.formula.html = calculationQuery;
                    }
                    else{
                        calculateAry = calculateAry.slice(0,-2);
                        this.properties.formula.html = calculateAry.join("</span>");
                        if(calculateAry.length) this.properties.formula.html = this.properties.formula.html + "</span>"
                    }
                };
                //validating the target fields value against validate type(decimal/integer) for the selected textbox field 
                this.convertNumber = function(index){
                    let numberType = this.properties.list.listItem[index].field.value.type;
                    let currentNum = this.properties.list.listItem[index].target.value;
                    if(this.properties.list.listItem[index].field.value == ""){
                        self.ngNotification.error({ message: "Please select a field!", positionX: 'center', replaceMessage: true });
                        return;
                    }
                    if(currentNum != "" && numberType){
                        if(numberType.toLowerCase() == "decimal" && currentNum % 1 == 0){
                            this.properties.list.listItem[index].target.value = Number(currentNum.toFixed(2));
                        }
                        else if(numberType.toLowerCase() == "integer"){
                            if(currentNum % 1 != 0){
                                self.ngNotification.error({ message: "Please enter an integer", positionX: 'center', replaceMessage: true });
                                this.properties.list.listItem[index].target.value = 0;
                                return;
                            }
                        }
                    }
                };
                this.onDragStart = function(item){
                    selectedOperator = item.operator.options.value;
                };
                this.initialSelectedOption = function(){
                    this.properties.list.listItem.forEach(item =>{
                        if(item.operator.selected)
                        item.operator.options.value = item.operator.selected;
                        else
                        item.operator.options.value = "Equal to";
                    });
                };
                //setting the selected operator value on dragging the conditon li
                this.logListEvent = function(index){
                    this.properties.list.listItem[index].operator.options.value = selectedOperator;
                    this.properties.list.listItem[index].operator.selected = selectedOperator;
                },
                this.updateOperatorValue = function(currentValue,index){
                    //updating selected with current value
                    if (this.properties.list.listItem[index].operator.options) {
                        this.properties.list.listItem[index].operator.selected = currentValue;
                    }
                    //disabling target field if operator is selected as empty/not empty
                    if(this.properties.list.listItem[index].operator.selected == "Empty" || this.properties.list.listItem[index].operator.selected == "Not empty")
                    this.properties.list.listItem[index].target.disable = true
                    else
                    this.properties.list.listItem[index].target.disable = false
                },
                //toggling advance tab
                this.showCalculationMethod = function($event){
                    this.properties.formula.html = '';
                    // angular.element("#calculationFormulaDiv").html("");
                    this.properties.formula.advanceQuery = "";

                    let selectedoption = $event.target.innerText;
                    if(selectedoption == "Advanced"){
                        this.properties.Type.calculation = 'advance';
                    }
                    else{
                        this.properties.Type.calculation = '';
                    }
                },
                //setting input text for advance query on selecting option from dropdown
                this.setQueryVal = function(event){
                    let selectedElem = event.target.innerText;
                    let existingquery = angular.element("#inputQuery").val();
                    if(selectedElem != "" && existingquery != ""){
                        existingquery = existingquery.slice(0, -1);
                        existingquery = existingquery + selectedElem;
                        this.properties.formula.advanceQuery = existingquery;
                    }
                },
                //adding prefix sum for repeating table fields
                this.addSum = function(selectedField){
                    let calculationQuery = this.properties.formula.html,
                    optIndex = calculationQuery.lastIndexOf('<span class="calculateOptSpan">'),
                    bracesIndex = calculationQuery.lastIndexOf('<span class="calculateBracesSpan">');     
                    if(optIndex != -1) optIndex = optIndex + 31;
                    else optIndex == 0;          
                    if(angular.isObject(selectedField) && selectedField.value && this.checkForOperator(optIndex,calculationQuery,bracesIndex)){
                        this.properties.formula.html = this.properties.formula.html + '<span class="calculateFieldSpan">sum({'+selectedField.value+'})</span>';
                        this.properties.list.listItem[0].addField.value = "";
                        this.properties.list.listItem[0].addSum.disable = true;
                    }                    
                },
                //toggling add field/sum buttons based upon field selected
                this.setaddType = function(selectedVal){
                    let isFieldTypeRepeating = properties.Type.numberUnderRepeatingTable;
                    let numberFieldsunderRptngTbl =  self.Util.getNumberFieldNamesunderRepeatingTbl();
                    let numberFields = self.Util.getNumberFieldNames();
                    //for enabling sum button for footer calculated fields
                    if(properties.parentNode.footer) isFieldTypeRepeating = false;

                    if(angular.isObject(selectedVal)){
                        numberFields.forEach(field => {
                            if(field.key == selectedVal.key){
                                this.properties.list.listItem[0].addField.disable = false;
                                this.properties.list.listItem[0].addSum.disable = true;
                            }
                        });
                        numberFieldsunderRptngTbl.forEach(field => {
                            if(field.key == selectedVal.key && !isFieldTypeRepeating){
                                isFieldTypeRepeating = true;
                                this.properties.list.listItem[0].addSum.disable = false;
                                this.properties.list.listItem[0].addField.disable = true;
                            }
                        });
                    }
                },
                this.EnableEditing = function (text) {
                    if( text == "Edit"){
                        this.properties.formula.edit = true;
                        this.properties.formula.editText = "Back";
                        this.properties.Value.selectedValue = this.properties.formula.html
                                            .replace(/<span class="calculateFieldSpan">/g,' ')
                                            .replace(/<span class="calculateOptSpan">/g,' ')
                                            .replace(/<span class="calculateNumSpan">/g,' ')
                                            .replace(/<span class="calculateBracesSpan">/g,' ')
                                            .replace(/<\/span>/g,' ');
                    }
                    else{
                        this.properties.formula.edit = false;
                        this.properties.formula.editText = "Edit";
                        this.syncCalcQuery(true);
                    }
                },
                this.showMsg = function(){
                    let msg = "Invalid Query! Your query do not comply to one or all of the instruction mentioned below:<br><br>"+
                    "Query should contain only valid syntax and parameters as mentioned below:<br>"+
                    "- Integer or Decimal Number<br>"+
                    "- Brackets ( Curly Brackets i.e. '{ }' OR Rounded Brackets i.e. '( )' )<br>"+
                    "- Mathematical Operators ( +, -, *, / )<br>"+
                    "- All Field Name used in design e.g. 'Total', 'Quantity', 'Cost'<br>"+
                    "- Use Rounded Brackets for any sub calculations e.g. ( {Quantity}*{Cost}) + ({Cost}*0.10)<br>"+
                    "- Only numeric field name to be used, and field name should match to any existing defined field name.<br>"+
                    "- Field name must be used within curly bracket without any space in between e.g. {Quantity}<br><br>"+
                    "Please update the query, and try saving it again."
                    self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                    return;
                },
                this.isUndefined = function (o) {
                    return typeof o === 'undefined';
                },
                this.sub = function (s, o, re) {
                    re = re || (/\{\s*([^\|\}\}]+?)\s*(?:\|([^\}\}]*))?\s*\}/g);
                    return ((s.replace) ? s.replace(re, function (match, key) {
                        return (!this.isUndefined(o[key])) ? o[key] : match;
                    }) : s);
                }
                this.syncCalcQuery = function(editTrue){
                    let sync = this.properties.formula.edit,
                    editedHtml = this.properties.formula.html,
                    editedValue = this.properties.Value.selectedValue, returnType = true,
                    parentNodeId = this.properties.parentNode && this.properties.parentNode.id,
                    isFooter = this.properties.parentNode && this.properties.parentNode.footer;
                    let mathFunAry = ["math.min","math.max","math.mean","math.median","math.prod","math.variance","math.std"];

                    if(sync || editTrue){
                        let splitAry = [];
                        if(editedValue.indexOf("math.sum") != -1)
                            editedValue = editedValue.replace(/math.sum/g,'MATH_SUM_FUN');
                        if(editedValue.indexOf("sum({") != -1){
                            let tempAry = editedValue.split("sum(");
                            for(let t=0;t<tempAry.length;t++){
                                let str = tempAry[t].substr(1,tempAry[t].indexOf("})"))
                                if(str != "" && str.indexOf("{") == -1)
                                tempAry[t] = "sum("+tempAry[t].replace(")","");
                            }
                            editedValue = tempAry.join("");
                        }
                        splitAry = editedValue.split("}");
                        
                        for(let s=0;s<splitAry.length;s++){
                            let split = splitAry[s];

                            if(split.indexOf("{") != -1){    
                                let str = split,isMathFun=false;
                                for(let m=0;m<mathFunAry.length;m++){
                                    if(str.indexOf(mathFunAry[m]) != -1){
                                        str=str.substr(str.indexOf(mathFunAry[m]),str.length);
                                        isMathFun = true;
                                    }
                                }
                                if(!isMathFun){
                                    if(str.indexOf("sum(") != -1)                                
                                    str=str.substr(str.indexOf("sum("),str.length);
                                    else
                                    str=str.substr(str.indexOf("{"),str.length);
                                }
                                
                                str = angular.element.trim(str);
                                let views = self.views,itemsAry=[],matchFound=false;
                                for (let view in views) {
                                    for(let v=0;v<self.Util.getIteams(views[view].controls.A).length;v++){
                                        itemsAry.push(self.Util.getIteams(views[view].controls.A)[v]);
                                    }
                                }
                                if(parentNodeId){
                                    itemsAry = self.Util.getNumberFieldNamesunderRepeatingTbl(undefined,undefined,parentNodeId);
                                    for(let i=0;i<itemsAry.length;i++){
                                        let item = itemsAry[i];
                                        for(let m=0;m<mathFunAry.length;m++){
                                            if((item.value == str.replace("{","").replace("}","").replace("sum(","").replace(")","").replace(mathFunAry[m],"")) && ((str.indexOf("sum(") == -1 && str.indexOf(mathFunAry[m]) == -1) ||isFooter))
                                            matchFound = true;
                                        } 
                                    }
                                }
                                else{
                                    for(let i=0;i<itemsAry.length;i++){
                                        let item = itemsAry[i];
                                        if(item.type == "Display field" || item.type == "Textbox"){
                                            if(item.properties.Basic.parentNode && item.properties.Basic.parentNode.id){
                                                for(let m=0;m<mathFunAry.length;m++){
                                                    if((item.properties["Basic"]["Field Name"].selectedValue.replace("{","").replace("}","") == str.replace("{","").replace("}","").replace("sum(","").replace(")","").replace(mathFunAry[m],"")) && (editedValue.indexOf("sum(") == -1 || str.indexOf("sum(") != -1)) 
                                                    matchFound = true;
                                                }    
                                            }
                                            else{
                                                for(let m=0;m<mathFunAry.length;m++){
                                                    str = angular.element.trim
                                                    (str.replace("{","").replace("}","").replace("sum(","").replace(")","").replace(mathFunAry[m],"").replace("(",""))
                                                    if(item.properties["Basic"]["Field Name"].selectedValue.replace("{","").replace("}","") == str && str.indexOf("sum(") == -1) 
                                                    matchFound = true;
                                                }
                                            }
                                        }
                                    }
                                }

                                if(!matchFound)
                                returnType = false;
                                else{
                                    if(isMathFun){
                                        let rplc =str.substr(str.indexOf("(")+1,str.length);
                                        splitAry[s] = splitAry[s].replace(rplc,"1");
                                    }
                                    else
                                    splitAry[s] = splitAry[s].replace(str,"1");

                                    splitAry[s] = splitAry[s].replace("{","")
                                }
                            }
                        }
                        try{
                            let finalQry = splitAry.join(" ");
                            finalQry = finalQry.replace(/MATH_SUM_FUN/g,'math.sum');
                            
                            if(eval(finalQry) || eval(finalQry) == 0){
                                editedValue = editedValue
                                                .replace(/\//g,'<span class="calculateOptSpan">/</span>')
                                                .replace(/\+/g,'<span class="calculateOptSpan">+</span>')
                                                .replace(/\*/g,'<span class="calculateOptSpan">*</span>')
                                
                                splitAry = editedValue.split("}");

                                for(let s=0;s<splitAry.length;s++){
                                    let split = splitAry[s];

                                    if(split.indexOf("{") != -1){
                                        let str = split;
                                        if(str.indexOf("sum(") != -1)
                                            str = str.substr(0,str.indexOf("sum({"));
                                        else
                                            str = str.substr(0,str.indexOf("{"));
                                        
                                        str = str.replace(/\-/g,'<span class="calculateOptSpan">-</span>')
                                                .replace(/\(/g,'<span class="calculateBracesSpan">(</span>')
                                                .replace(/\)/g,'<span class="calculateBracesSpan">)</span>')
                                                .replace(/\'/g,'<span class="calculateOptSpan">\'</span>')
                                                .replace(/\]/g,'<span class="calculateOptSpan">\]</span>')
                                                .replace(/\[/g,'<span class="calculateOptSpan">\[</span>')
                                                .replace(/\,/g,'<span class="calculateOptSpan">,</span>');
                                        if(split.indexOf("sum(") != -1)    
                                            splitAry[s] = str + '<span class="calculateFieldSpan">'+split.substr(split.indexOf("sum({"),split.length)+'})</span>'
                                        else
                                            splitAry[s] = str + '<span class="calculateFieldSpan">'+split.substr(split.indexOf("{"),split.length)+'}</span>'
                                    }
                                    else{
                                        splitAry[s] = splitAry[s]
                                                .replace(/\-/g,'<span class="calculateOptSpan">-</span>')
                                                .replace(/\(/g,'<span class="calculateBracesSpan">(</span>')
                                                .replace(/\)/g,'<span class="calculateBracesSpan">)</span>')
                                                .replace(/\'/g,'<span class="calculateOptSpan">\'</span>')
                                                .replace(/\]/g,'<span class="calculateOptSpan">\]</span>')
                                                .replace(/\[/g,'<span class="calculateOptSpan">\[</span>')
                                                .replace(/\,/g,'<span class="calculateOptSpan">,</span>');
                                    }
                                }
                                let numSplitAry = splitAry.join("").split("</span>");
                                for(let s=0; s<numSplitAry.length;s++){
                                    let str = numSplitAry[s].substr(0,numSplitAry[s].indexOf("<span"));
                                    if(angular.element.trim(str) != "" || parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) == 0){
                                        if(parseFloat(str) || parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) ==0){
                                            if(parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) == 0)
                                            str = parseFloat(numSplitAry[s]).toString();
                                            
                                            numSplitAry[s] = numSplitAry[s].replace(new RegExp(str),'<span class="calculateNumSpan">'+str+'</span>')
                                        }
                                        else{
                                            numSplitAry[s] = numSplitAry[s].replace(new RegExp(str),'<span class="calculateFieldSpan">'+str+'</span>')
                                        }
                                    }
                                }
                                let finalHTML = numSplitAry.join("</span>").replace(/MATH_SUM_FUN/g,'math.sum');
                                this.properties.formula.html = finalHTML;
                            }
                            else{
                                this.showMsg();
                                returnType = false;
                            }
                        }
                        catch (err){
                            this.showMsg();
                            returnType = false;
                        }
                    }
                    return returnType;
                };
            }
        });
    }
    updateFieldName(fieldName,oldFieldName,uid){       
        let views = this.views,controls=[],newFieldNameCount=0;
        if (Object.keys(views).length) {
            for (let view in views) {
              for(let v=0;v<this.Util.getIteams(views[view].controls.A).length;v++){
                controls.push(this.Util.getIteams(views[view].controls.A)[v]);
              }
            }
            if (controls.length) {                
                for (let c = 0; c < controls.length; c++) {
                    let control = controls[c];
                    if(!control.copiedFrom && control.properties.Basic && control.properties.Basic["Field Name"] && control.properties.Basic["Field Name"].selectedValue == fieldName){
                        newFieldNameCount += 1;
                    } 
                }
                if(newFieldNameCount > 1){
                    this.ngNotification.error({ message: "Duplicate Field Name : " + fieldName, positionX: 'center', replaceMessage: true });
                    return;
                }

                for (let i = 0; i < controls.length; i++) {
                    let control = controls[i];
                    if(control.type == "Display field"){
                        if(control.properties["Basic"]["DSName"].selectedValue == "calculated"){
                            let UidAry = control.properties["Basic"]["formula"] && control.properties["Basic"]["formula"]["uids"];
                            if(UidAry.length && UidAry.indexOf(uid) != -1){
                                let valueSplitAry = control.properties["Basic"]["Value"].selectedValue.split("}");
                                for(let s=0;s<valueSplitAry.length;s++){
                                    let split = valueSplitAry[s];
                                    if(split.indexOf("{") != -1){
                                        let str = split.substr(split.indexOf("{"),split.length);
                                        str = str.replace("{","").replace("}","").replace("sum(","").replace(")","")
                                        if(oldFieldName.replace("{","").replace("}","") == str){                                    
                                            valueSplitAry[s] = valueSplitAry[s].substr(0,valueSplitAry[s].indexOf("{")+1) + fieldName;
                                        }                                    
                                    }
                                }
                                control.properties["Basic"]["Value"].selectedValue = valueSplitAry.join("}");
                                let htmlSplitAry = control.properties["Basic"]["formula"].html.split('}');                            
                                for(let h=0;h<htmlSplitAry.length;h++){
                                    let split = htmlSplitAry[h];
                                    if(split.indexOf("{") != -1){
                                        let str = split.substr(split.indexOf("{"),split.length);
                                        str = str.replace("{","").replace("}","").replace("sum(","").replace(")","")
                                        if(oldFieldName.replace("{","").replace("}","") == str){
                                            htmlSplitAry[h] = htmlSplitAry[h].substr(0,htmlSplitAry[h].indexOf("{")+1) + fieldName;
                                        }                                    
                                    }
                                }
                                control.properties["Basic"]["formula"].html = htmlSplitAry.join("}");
                            }
                        }
                    }
                }
            }    
        }
    }
    /**
     * Search and set fixedfield value in properties from user friendly names.
     *
     * @param {any} properties
     * @memberof PropertyboxComponent
     */
    updateDSField(properties) {
        let value = properties.Value.selectedValue
        let self = this;
        let fields = self.Util.getDataFieldNames();
        fields = fields.concat(self.Util.getFixedFields(true));
        
        let regex = /(^\{\{.*?\}\}$)/;
        if (typeof(value) !=='boolean' && value.match(regex)) {
            let val = value.replace('{{', '').replace('}}', '');
            let field = fields.filter(function (value) {
                return value.key == val;
            });
            if (field.length) {
                properties.DSName.selectedValue = field[0].value;
            } else {
                properties.DSName.selectedValue = '';
            }
        } else {
            properties.DSName.selectedValue = '';
        }
        if(value == "") {
            this.resetCondition(properties);
        }
        
    }
    //reseting to default if calculation query removed and saved
    resetCondition(properties){
        properties.Value.readonly = false;
        properties.DSName.selectedValue = "";
        properties.Value.selectedValue = "";
        if(properties.formula) {
            properties.formula.hidden = true;
            properties.formula.selectedValue = "";
            properties.formula.html = "";
            properties.formula.rules = "";
        }
        if(properties.list) {
            properties.list.listItem.forEach(item =>{
                item.field.value = '';
                item.operator.options.value = "Equal to";
                item.operator.selected = "Equal to";
                item.target.value = 0;
                item.target.disable = false;
                item.conjuction.hidden = true;
                item.addField.value = '';
                item.remove.hidden = true;
            });
            properties.list.listItem = properties.list.listItem.filter(function(item){
                if(item.field.value != "" || item.id == 0) 
                return item;
            });
        }
    }
    /**
     * Check and Update style of current control's children.
     *
     * @param {any} key
     * @returns
     * @memberof PropertyboxComponent
     */
    updateStyle(key) {
        /* let selectedItem = this.getSelectedItem();
        if (!Object.keys(selectedItem).length || (selectedItem.type != "Layout" && selectedItem.type != "RepeatingTable" && selectedItem.type != "Table"))
            return;
        let properties = selectedItem.properties.Style;
        let children = selectedItem.data;
        this.updateChildStyle([selectedItem], properties, key); */
    }

    /**
     * Update child's style property with parent(Layout, Table)
     *
     * @param {any} controls
     * @param {any} properties
     * @param {any} key
     * @memberof PropertyboxComponent
     */
    updateChildStyle(controls, properties, key) {
        let self = this;
        if (controls.length) {
            for (let i = 0; i < controls.length; i++) {
                if (controls[i].type == "Image") {
                    key == 'alignment' && (controls[i].properties.Style['font-style-group'].members.alignment.selectedValue = properties['style-group'].members.alignment.selectedValue);
                    key == 'background-color' && (controls[i].properties.Style['font-style-group'].members['background-color'].selectedValue = properties['font-style-group'].members['background-color'].selectedValue);
                } else {
                    if (key == 'font-family' || key == 'font-size' || key == 'background-color') {
                        controls[i].properties.Style['font-style-group'].members[key].selectedValue = properties['font-style-group'].members[key].selectedValue;
                    } else if (key == 'bold' || key == 'italic' || key == 'underline' || key == 'alignment' || key == 'font-color') {
                        controls[i].properties.Style['style-group'].members[key].selectedValue = properties['style-group'].members[key].selectedValue;
                    }
                }
                if (controls[i].type == "Layout") {
                    self.Util.accessLayoutElements(controls[i], function (elems) {
                        self.updateChildStyle(elems, properties, key);
                    });
                }
                if (controls[i].type == "Table") {
                    self.Util.accessTableElements(controls[i], function (elems) {
                        self.updateChildStyle(elems, properties, key);
                    });
                }
                if (controls[i].type == "RepeatingTable") {
                    self.Util.accessRepeatingTableElements(controls[i], function (elems) {
                        self.updateChildStyle(elems, properties, key);
                    });
                }
                if (controls[i].type == "Section") {
                    self.Util.accessSectionElements(controls[i], function (elems) {
                        self.updateChildStyle(elems, properties, key);
                    });
                }
            }
        }
    }
     /**
     * Update value on /off for toggle button,
     * Also check if it is empty and notify user
     * @param {any} properties
     * @memberof PropertyboxComponent
     */
    updateValueText(properties,fieldName) {
        if (fieldName == 'value.on' && properties['ValueOn'].selectedValue == '') {
            var msg = 'Please enter the required '+this.$translate.instant(fieldName) + ' input';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        } else if(fieldName == 'value.off' && properties['ValueOff'].selectedValue == '') {
            var msg = 'Please enter the required '+this.$translate.instant(fieldName) + ' input';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        }
    }

    /**
         * hide and show the working Days property based on date dateType
         *
         * @param {any} dateType
         * @param {any} properties
         * @memberof PropertyboxComponent
         */
    updateDateType(dateType, properties) {
         if (dateType == '2') {
            properties['Working Days'].hidden = false;
        } else {
            properties['Working Days'].hidden = true;
            properties['Working Days'].selectedValue = false;
        }
    }

    /**
     * Update default value from date picker
     *
     * @param {any} dateFormat
     * @param {any} properties
     * @memberof PropertyboxComponent
     */
    updateDefaultDate(dateFormat, properties) {
        let selectedItemProps = this.getSelectedItemProperties();
        let pickerId = this.getSelectedItem().uid,isDateEmpty = true,
         myDateElem = angular.element("input[picker-id="+pickerId+"]"),
         myPropDateElem = angular.element("input[picker-id=p_"+pickerId+"]"),
         sideBySide = true,
         dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;

        
        if(properties['Time'] && properties['Time'].selectedValue)  {
            selectedItemProps.Advance["Closed Date"].selectedValue = false;
            selectedItemProps.Advance["Closed Date"].disable = true; 
            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
        } else {
            selectedItemProps.Advance["Closed Date"].disable = false;
        }
        if(properties['Default'].selectedValue) {
            isDateEmpty = false;
        }
        var value = properties.Default.dateObj;
        
        myDateElem.datetimepicker('destroy');
        myPropDateElem.datetimepicker('destroy');
        // Re-int with new options
        myDateElem.datetimepicker({
            format:dateTimeFormat,
            sideBySide:sideBySide,
            showClear:true,
            showClose:true,
            showTodayButton:true,
            allowInputToggle:true,
            keepOpen: false,
            useCurrent:false,
            toolbarPlacement: "bottom",
            locale:this.config.languageId.split('_')[0],
            icons: {
                close: 'closeText',
                clear: 'clearText',
                today: 'todayText'
            }

        });
        myPropDateElem.datetimepicker({
            format:dateTimeFormat,
            sideBySide:sideBySide,
            showClear:true,
            showClose:true,
            showTodayButton:true,
            allowInputToggle:true,
            keepOpen:false,
            useCurrent:false,
            toolbarPlacement: "bottom",
            locale:this.config.languageId.split('_')[0],
            icons: {
                close: 'closeText',
                clear: 'clearText',
                today: 'todayText'
            }
        });
        if(!isDateEmpty && value) {
            myDateElem.data('DateTimePicker').date(value);
            myPropDateElem.data('DateTimePicker').date(value);
        }
    }
    updateDefaultTime(format,properties) {
        let pickerId = this.getSelectedItem().uid;
        this.setTimeFormat(properties);
        let timeFormat = format == 'true' ? 'hh:mm A' : 'HH:mm';
        let defaultValue = _.get(properties, 'Default.selectedValue', '');
        _.set(properties, 'Default.currentTime', moment(new Date()).format(timeFormat));
        if (defaultValue) {
            _.set(properties, 'Default.dateObj', moment(defaultValue,timeFormat).toDate());
        }
    }
    setTimeFormat(properties) {
        properties['timeFormat'] = properties['timeFormat'] ? properties['timeFormat'] : 'HH:mm';
        let selectedItem = this.getSelectedItem(),timeFormat = 'HH:mm';
        if (properties['Time Format']) {
            timeFormat = properties['Time Format'].selectedValue == 'true' ? 'hh:mm a' : 'HH:mm';
            selectedItem.timeFormat = timeFormat;
            properties['timeFormat'] = timeFormat;
        }
    }
    getTimePickerOptions(properties) {
        if(properties['Time Format']){
            this.timePickerOptions.showMeridian = JSON.parse(properties['Time Format'].selectedValue);
            return this.timePickerOptions;
        }
    }

    checkValidInput(event,properties) {
        if (event.currentTarget) {
            if (event.currentTarget.className.indexOf('ng-invalid') != -1) {
                properties.Default.selectedValue = null;
            }
        } 
    }

    checkValidInputDate(properties) {
        let dateTimeFormat =  properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') :  properties['Display Format'].selectedValue;
        if( properties['Time'] &&  properties['Time'].selectedValue)  {
            dateTimeFormat =  properties['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
        }
        let itemVal =  properties['Default'].selectedValue;
        itemVal = moment(itemVal,dateTimeFormat).toDate();
        if (itemVal == 'Invalid Date') {
            if(  properties['Default']['dateObj']){
            properties['Default'].selectedValue = moment(  properties['Default']['dateObj']).format(dateTimeFormat);
            } else {
            properties['Default'].selectedValue = '';
            }
        } else if(itemVal != 'Invalid Date' &&   properties['Default']['dateObj']) {
        properties['Default'].selectedValue = moment( properties['Default']['dateObj']).format(dateTimeFormat);
        }
    }

    updatePickerDisplay(event, properties) {
        event.preventDefault();
        var dateElemPicker = angular.element(event.currentTarget);
        dateElemPicker.data("DateTimePicker").keyBinds({ 't': null });
        var curFormat = dateElemPicker.data("DateTimePicker").options().format;
        var dateobj = properties['Default'].dateObj;
        if (dateobj) {
            if ((properties['Default'].selectedValue && properties['Default'].selectedValue.length) == curFormat.length) {
                dateElemPicker.data('DateTimePicker').date(dateobj);
            }
        }
    }

    getDatePickerOptions(properties) {
        let dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
        if(properties['Time'] && properties['Time'].selectedValue)  {
            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
        }
        this.datePickerOptions.format = dateTimeFormat;
        properties.pickerOptions =  this.datePickerOptions;
        
    }

    getParsedDate(properties) {
        let dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
        if (properties['Time'] && properties['Time'].selectedValue) {
            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm'
        }
        let itemVal = properties['Default'].selectedValue;
        itemVal = moment(itemVal, dateTimeFormat).toDate();
        if (itemVal != 'Invalid Date') {
            properties['Default'].dateObj = moment(itemVal, dateTimeFormat).toDate();
        } else if (properties['Default'].selectedValue == '' || properties['Default'].selectedValue == undefined) {
            properties['Default'].dateObj = '';
        }
    }
    openDatepicker(properties) {
        let pickerId = this.getSelectedItem().uid,
         myPropDateElem = angular.element("input[picker-id=p_"+pickerId+"]");
         myPropDateElem.datetimepicker('toggle');
    }

    updateRows () {
        this.getListItems();
    }

    getRows() {
        let selectedItem = this.getSelectedItemProperties();
        if (selectedItem) { 
            let columnCount = _.get(selectedItem, '["Basic"].Number.selectedValue', 1);
            if(columnCount <= 0) columnCount = 1;
            let rowsArr = _.get(selectedItem, '["Data Source"].table.list',[]);
            let rowsCount = rowsArr.length;
            rowsCount = Math.ceil(rowsCount/columnCount);
            return rowsCount;
        }
    }
    
    getListItems() {
        let selectedItem = this.getSelectedItem();
        let selectedItemProperties = this.getSelectedItemProperties();
        if (selectedItem) {
            let rowsArr = _.get(selectedItemProperties, '["Data Source"].table.list', []);
            let columnCount = _.get(selectedItemProperties, '["Basic"].Number.selectedValue', 1);
            if (columnCount <= 0) columnCount = 1;
            let rows = this.getRows();
            let items = [];
            for (let i = 0; i < rows; i++) {
                let rowItems = [];
                for (let j = 0; j < columnCount; j++) {
                    if (rowsArr[j + (i * columnCount)]) {
                        rowItems.push(rowsArr[j + (i * columnCount)]);
                    }
                }
                items.push(rowItems);
            }
            selectedItem.optionsList = items;
        }
    }

    mapTypeChanged(value, properties) {
        _.set(properties, 'Default.selectedValue', '');
    }

    openDSHelp() {
        let form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = '/help';
        form.style.display = "none";

        let input = document.createElement("input");
        input.type = "hidden";
        input.name = 'USP';
        input.value = JSON.stringify(this.$rootScope.USP);
        let inputBrandingId = document.createElement("input");
        inputBrandingId.type = "hidden";
        inputBrandingId.name = 'brandingId';
        inputBrandingId.value = this.config.brandingId;
        form.appendChild(inputBrandingId);
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

    }

    resetDefaultForRadio(value, list) {
        if (list.length) {
            for (var i = 0; i < list.length; i++) {
                var element = list[i];
                element.Default.name = '';
            }
        }
        value.name = true;
    }

    resetDefault() {
        let selectedItem = this.getSelectedItemProperties();
        if (selectedItem) {
            let dsType = _.get(selectedItem, '["Data Source"].Source.selectedValue', '');
            if (dsType == '3') {
                let list = _.get(selectedItem, '["Data Source"].table.list', []);
                for (var i = 0; i < list.length; i++) {
                    var element = list[i];
                    element.Default.name = '';
                }
            }
        }
    }
    validateMin(item) {
        if(item['Min'].selectedValue >= item['Max'].selectedValue) {
            let msg = this.$translate.instant('min.greater.max')
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        }
    }
    //toggling app status sync
    enableAppStatusSync(){
        
        let selectedItem = this.getSelectedItemProperties();
        if(selectedItem.Advance["App Status"].selectedValue == true){
            //seting default values on app sync status 
            let oldDataFieldName = selectedItem.Basic["Data Field Name"].selectedValue;
            selectedItem.Basic["Data Field Name"].selectedValue = "DS_ALL_FORMSTATUS";
            selectedItem.Basic["Data Field Name"].disable = true;
            this.restrictCharInDataFieldName("DS_ALL_FORMSTATUS", oldDataFieldName, true);


            selectedItem.Basic["Multi-Select"].disable = true;
            selectedItem.Basic["Multi-Select"].selectedValue = false;
            selectedItem["Data Source"].Source.selectedValue = '4';//setting data source as system data
            selectedItem["Data Source"].forceToDisabled = true; //Disable all data source radio button
            
            //setting the all form status as the selected value if app sync status enabled 
            let urls = this.Util.getFixedFields(selectedItem["Data Source"].fixedFieldUrl.singleValue);//fetching all the system fixed field values
            if(urls.length  && selectedItem.Advance["App Status"].selectedValue == true){
                for(var i=0;i<urls.length;i++){
                    if(urls[i].value == "DS_ALL_FORMSTATUS"){
                        if(selectedItem["Data Source"].fixedFieldUrl.selectedValue == "")
                        selectedItem["Data Source"].fixedFieldUrl.selectedValue = {};
                        _.set(selectedItem["Data Source"], 'fixedFieldUrl.selectedValue', urls[i]);
                    }
                }
            }
        }else{
            let fieldName = selectedItem.Basic["Field Name"].selectedValue;
            selectedItem.Basic["Data Field Name"].selectedValue = fieldName;
            this.restrictCharInDataFieldName(fieldName, "DS_ALL_FORMSTATUS", true);
            selectedItem.Basic["Data Field Name"].disable = false;
            selectedItem.Basic["Multi-Select"].disable = false;
            selectedItem.Advance["App Status"].selectedValue = false;
            //removing all form status as selected value, if app sync status disabled
            selectedItem["Data Source"].Source.selectedValue = '3';
            selectedItem["Data Source"].forceToDisabled = false; //Enable all data source radio button               
            _.set(selectedItem["Data Source"], 'fixedFieldUrl.selectedValue', "");
        }
    }

    //toggling closed date sync
    enableClosedDateSync(){
        let selectedItem = this.getSelectedItemProperties();
        if(selectedItem.Advance["Closed Date"].selectedValue == true){
            //setting default value if closed date sync enabled
            let oldDataFieldName = selectedItem.Basic["Data Field Name"].selectedValue;
            selectedItem.Basic["Data Field Name"].selectedValue = "DS_CLOSE_DUE_DATE";
            selectedItem.Basic["Data Field Name"].disable = true;
            this.restrictCharInDataFieldName("DS_CLOSE_DUE_DATE", oldDataFieldName, true);
            //setting datepicker as required, so it's mandatory to add a date when submitting a form
            selectedItem.Basic.Required.selectedValue = true;
            selectedItem.Basic.Required.disable = true;
            selectedItem.Basic.Time.selectedValue = false;
            selectedItem.Basic.Time.disable = true;
        }
        else{
            let fieldName = selectedItem.Basic["Field Name"].selectedValue;
            selectedItem.Basic["Data Field Name"].selectedValue = fieldName;
            this.restrictCharInDataFieldName(fieldName, "DS_CLOSE_DUE_DATE", true);
            selectedItem.Basic["Data Field Name"].disable = false;

            selectedItem.Basic.Required.selectedValue = false;
            selectedItem.Basic.Required.disable = false;

            selectedItem.Basic.Time.selectedValue = false;
            selectedItem.Basic.Time.disable = false;
        }
    }
    /**
     * @brief      Merge Table Cells
     *
     * @return     { Void }
     */
    mergeCell() {

        let item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];

        // Variables
        var isRowSpan,
            isColspan,
            row,
            col,
            selectedCellArray = [],
            isValid = true,
            colSpanCount = 1,
            rowSpanCount = 1;
        const rowSet:Set<number> = new Set<number>();
        const colSet:Set<number> = new Set<number>();
        let isSelectedCellIsRow:boolean = true;
        let isSelectedCellIsCol:boolean = true;

        // Find what user wants Rowspan/Colspan?
        var oldRow, oldCol, oldRowspan, oldColspan;
        item.ids.sort((a, b) => {
            let c = parseInt(a.split('-')[0]);
            let d = parseInt(b.split('-')[0]);
            return c - d;
        });
        item.ids.sort((a, b) => {
            let c = parseInt(a.split('-')[1]);
            let d = parseInt(b.split('-')[1]);
            return c - d;
        });
        item.ids.forEach(function (combination, index) {
            var cellRow = parseInt(combination.split("-")[0], 10),
                cellCol = parseInt(combination.split("-")[1], 10),
                colspan = (item.data[cellRow][cellCol].colspan) ? item.data[cellRow][cellCol].colspan : 1,
                rowspan = (item.data[cellRow][cellCol].rowspan) ? item.data[cellRow][cellCol].rowspan : 1;

            if (row === cellRow && isColspan !== false) {
                isColspan = true;
                colSpanCount = colSpanCount + colspan;
            }
            if (((oldCol + 1) !== cellCol && isColspan === true || rowspan > 10)  || (oldRowspan > 1 && rowspan === 1) || (oldRowspan === 1 && rowspan > 1)) {
                isColspan = false;
            }

            if (col === cellCol && isRowSpan !== false) {
                isRowSpan = true;
                rowSpanCount = rowSpanCount + rowspan;
            }
            if (((oldRow + 1) !== cellRow && isRowSpan === true || colspan > 10) || (oldColspan > 1 && colspan === 1) || (oldColspan === 1 && colspan > 1)) {
                isRowSpan = false;
            }

            if (index === 0) {
                row = cellRow;
                col = cellCol;
            }

            oldRow = cellRow + (rowspan - 1);
            oldCol = cellCol + (colspan - 1);

            oldRowspan = rowspan;
            oldColspan = colspan;

            selectedCellArray.push([cellRow, cellCol]);

            // Adding row and col into the Set
            rowSet.add(cellRow);
            colSet.add(cellCol)
        });

        // check for the rowSet and colSet size, if it is equal to one or not, if not then show the error msg.
        isSelectedCellIsRow = rowSet.size === 1;
        isSelectedCellIsCol = colSet.size === 1;

        // Count cells
        var cellCount = item.ids.length;

        // Validate Selection
        if (item.ids.length === 0) {
            this.ngNotification.error({ message: "Please use Shift+Right Click to select cell in table", positionX: 'center', replaceMessage: true });
            return;
        }
        if ((!isSelectedCellIsRow && !isSelectedCellIsCol) || (!isColspan && !isRowSpan)) {
            this.ngNotification.error({ message: 'Invalid Selection.', positionX: 'center', replaceMessage: true });
            item.reset = true;
            item.ids = [];
            return false;
        }

        // Apply colspan/rowspan
        if (isColspan) {
            if (item.data[row][col].colspan) {
                item.data[row][col].colspan = item.data[row][col].colspan + (colSpanCount - 1);
            } else {
                item.data[row][col].colspan = colSpanCount;
            }
        }
        if (isRowSpan) {
            if (item.data[row][col].rowspan) {
                item.data[row][col].rowspan = item.data[row][col].rowspan + (rowSpanCount - 1);
            } else {
                item.data[row][col].rowspan = rowSpanCount;
            }
        }

        selectedCellArray.forEach((cell, index) => {
            if (index === 0) {
                return;
            }
            item.data[cell[0]][cell[1]].hide = true;
        });

        item.reset = true;
        item.ids = [];
    }

    splitCell() {
        let item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
        let selectedCells = item.ids;

        if (!selectedCells || !selectedCells.length) {
            return;
        }

        for (var i = 0; i < selectedCells.length; i++) {
            let cell = selectedCells[i],
                cellRow = parseInt(cell.split("-")[0], 10),
                cellCol = parseInt(cell.split("-")[1], 10),
                rowSpan = item.data[cellRow][cellCol].rowspan,
                colSpan = item.data[cellRow][cellCol].colspan;
            if (rowSpan) {
                for (var j = 1; j < rowSpan; j++) {
                    item.data[cellRow + j][cellCol].hide = false;
                    item.data[cellRow + j][cellCol].rowspan = '';
                }
            }

            if (colSpan) {
                for (var j = 1; j < colSpan; j++) {
                    item.data[cellRow][cellCol + j].hide = false;
                    item.data[cellRow][cellCol + j].colspan = '';
                }
            }

            item.data[cellRow][cellCol].rowspan = '';
            item.data[cellRow][cellCol].colspan = '';
            item.reset = true;
        }
    }

    showColorPicker($event) {
        $event.stopPropagation();
        $event.preventDefault();
        angular.element($event.currentTarget).closest('.color-picker').find('.spectrum-color-picker').trigger('click');
    }

    removeWidth() {
        let item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
        item.width = {};
    }

    removeRow() {
        let item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];

        if (item.selectedRows.length === item.data.length) {
            alert("Can not remove all rows.");
            return false;
        }
        for (var i = item.selectedRows.length - 1; i >= 0; i--) {
            item.data.splice(item.selectedRows[i], 1);
            item.properties.Display.Rows.selectedValue -= 1;
        }
        item.selectedRows = [];
    }    
    //add new rule
    addNewRuleDiv(index, item, list) {
        let lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }));
        let copiedItem = angular.copy(item);
        
        copiedItem['id'] = lastId + 1;
        list.splice((index + 1), 0, copiedItem);
        
        list[index+1].field.value = '';
        list[index+1].target.value = 0;
        list[index].conjuction.hidden = false;
        list[index].remove.hidden = false;
    }
    //removing existing rule
    removeRuleDiv(index, list) {
        list.splice(index, 1);
    }
    //updating value type to number for selected calculation fields/textbox(type - decimal/integer)
    updateValueType(){
        let validateselectedtype,dsFieldCount = 0,textboxCount = 0;
        let selectedItems = [];
        for (let view in this.views) {
            for(let v=0;v<this.Util.getIteams(this.views[view].controls.A).length;v++){
                selectedItems.push(this.Util.getIteams(this.views[view].controls.A)[v]);
            }
        }

        selectedItems.forEach(label => {
            if(label.type.toLowerCase() == "display field") dsFieldCount++;
        });
        selectedItems.forEach(textbox => {
            if(textbox.type.toLowerCase() == "textbox"){
                validateselectedtype = textbox.properties.Basic.Validate.selectedValue;
                if(validateselectedtype != "" && (validateselectedtype == "Integer" || validateselectedtype == "Decimal")) textboxCount++;
            } 
        });

        selectedItems.forEach(item => {
            if(item.type.toLowerCase() == "textbox" && item.properties.Basic.Type){
                if(dsFieldCount > 1 || textboxCount > 0) item.properties.Basic.Type.number = true;
                else item.properties.Basic.Type.number = false;
            }
            else if(item.type.toLowerCase() == "display field" && item.properties.Basic.Type){
                if(dsFieldCount > 1 || textboxCount > 0) item.properties.Basic.Type.number = true;
                else item.properties.Basic.Type.number = false;
            }
        });
    }
    //return counts for calculated fields and textbox(type - integer/decimal) added under repeating table
    returnFieldCounts(selectedItems,parentnode){
        let selectedcolumn,validateselectedtype, dsFieldCount = 0, textboxCount = 0;
        
        selectedItems.forEach(item => {
            if(item.type.toLowerCase() == "repeatingtable"){
                let tableId =  "repeatingTable"+item.id;
                if(tableId == parentnode){                    
                    item.data[0].forEach(data => {
                        selectedcolumn = data.elems[0];
                        selectedcolumn.forEach(column => {
                            if(column.properties.Basic && column.properties.Basic.parentNode && column.properties.Basic.parentNode.id == tableId){
                                if(column.type.toLowerCase() == "display field") dsFieldCount++;
                                else if(column.type.toLowerCase() == "textbox"){
                                    validateselectedtype = column.properties.Basic.Validate.selectedValue;
                                    if(validateselectedtype != "" && (validateselectedtype == "Integer" || validateselectedtype == "Decimal")) textboxCount++;
                                } 
                                else if(column.type.toLowerCase() == "repeatingtable"){
                                    this.returnFieldCounts([column],parentnode)
                                }
                            }
                        });
                    });
                }
            }
        });
        return [textboxCount,dsFieldCount];
    }
    //setting calculated fields and textbox as number type based upon the count, for fields under repeating table(s)
    updateRepeatingTableDSFieldType(selectedItems,textboxunderrepeatingtbl,parentnode){
        if(!angular.isObject(selectedItems)){
            selectedItems = [];
            for (let view in this.views) {
                for(let v=0;v<this.Util.getIteams(this.views[view].controls.A).length;v++){
                    selectedItems.push(this.Util.getIteams(this.views[view].controls.A)[v]);
                }
            }
        }
        
        let selectedcolumn, textboxCount = this.returnFieldCounts(selectedItems,parentnode)[0],
        dsFieldCount = this.returnFieldCounts(selectedItems,parentnode)[1];

        selectedItems.forEach(item => {
            if(item.type.toLowerCase() == "repeatingtable"){
                item.data[0].forEach(data => {
                    selectedcolumn = data.elems[0];
                    
                    selectedcolumn.forEach(column => {
                        if(column.type.toLowerCase() == "textbox"){
                            let parentnode = column.properties.Basic.parentNode.id;
                            if(dsFieldCount > 1 || textboxCount > 0){
                                this.returnFieldType(true,parentnode);
                                textboxunderrepeatingtbl = true;
                            }
                            else this.returnFieldType(false,parentnode);
                        }
                        else if(column.type.toLowerCase() == "display field"){
                            let parentnode = column.properties.Basic.parentNode.id;
                            if(dsFieldCount > 1 || textboxCount > 0){
                                this.returnFieldType(true,parentnode);
                            }
                            else this.returnFieldType(false,parentnode);
                        }
                        else if(column.type.toLowerCase() == "repeatingtable"){
                            this.updateRepeatingTableDSFieldType(selectedcolumn,textboxunderrepeatingtbl,parentnode)
                        }
                    });                    
                });                
            }
        });
    }
    returnFieldType(type,parentnode){
        let currentparentnodeId = this.getSelectedItemProperties().Basic.parentNode.id;
        if(parentnode == currentparentnodeId){
            if(type == true && currentparentnodeId != 0){                
                this.getSelectedItemProperties().Basic.Type.numberUnderRepeatingTable = true;
                this.getSelectedItemProperties().Basic.Type.number = true;
            }
            else{
                this.getSelectedItemProperties().Basic.Type.numberUnderRepeatingTable = false;
                this.getSelectedItemProperties().Basic.Type.number = false;
            }
        }
    }

    /**
     * Invoked when current selected control property is changed.
     */
     onPropValueChanged() {
        let self = this;
        let selectedItem = self.getSelectedItem();
        if (selectedItem && (selectedItem.type === 'InlineAssocFiles' || selectedItem.type === 'InlineAssocApps')) {
            self.updateLanguageData(selectedItem);
        }
        if(selectedItem.properties && selectedItem.properties.Basic) {
            let controlFieldName = selectedItem.properties.Basic['Field Name'] && selectedItem.properties.Basic['Field Name'].selectedValue;
            self.$rootScope.$broadcast('controlPropertyChanged', controlFieldName);
        }
    }
    setDisplayFormat(icon,value,properties){ 
        var selectedItem ='' ;
        var selectedIcon ='';
        properties['Display Format'].options.forEach(item => {
           if(value == item.value && icon == item.icon){
               selectedItem =item.key;
               selectedIcon =item.icon;
           }
        });  
        properties['Display Format'].selectedName = selectedItem;
        properties['Display Format'].selectedIcon = selectedIcon;
        properties['Display Format'].selectedValue =value;
    }

    isValidURL(str) {
        var a  = document.createElement('a');
        a.href = str;
        return (a.host && a.host != window.location.host);
    }
    
    onDigitSepratorToggle(properties, value) {
        properties.DecimalPlaces.hidden = properties.Validate.selectedValue != 'Decimal' || !value.selectedValue;

        if(value.selectedValue) {
            properties.DigitSeparator.addOnButton = properties.DigitSeparator.addOnButton.replace(' hidden', '');
        }else {
            properties.DigitSeparator.addOnButton += ' hidden';
        }
    }

    onFormatTypeChanged(selectedValue, properties) {
        this.updateValueType();

        if(this.numberFormatEnabled && (selectedValue == 'Integer' || selectedValue == 'Decimal')) {
            properties.DigitSeparator.hidden = false;
            properties.DecimalPlaces.hidden = selectedValue != 'Decimal' || !properties.DigitSeparator.selectedValue;
            properties.DecimalPlaces.selectedValue = "0";
        }else {
            properties.DigitSeparator.selectedValue = false;
            properties.DigitSeparator.hidden = true;
            properties.DecimalPlaces.hidden = true;
            properties.DecimalPlaces.selectedValue = "0";
        }
    }

    onThumbailSizeChanged(selectedValue, properties){
        if(selectedValue == 'customize'){
            properties['Thumbnail Width'].hidden = false;
            properties['Thumbnail Height'].hidden = false;
        }
        else{
            properties['Thumbnail Width'].hidden = true;
            properties['Thumbnail Height'].hidden = true;
        }
    }
    onThumbnailViewChanged(selectedValue, properties){
        if(selectedValue == true && properties['Thumbnail Size'].selectedValue =='customize'){
            properties['Thumbnail Width'].hidden = false;
            properties['Thumbnail Height'].hidden = false;
        }
        else{
            properties['Thumbnail Width'].hidden = true;
            properties['Thumbnail Height'].hidden = true;
        }
    }

    removeDuplicateData(properties){
                let list = properties.list
                let arrayOfValues = [];
                let arrayOfLabels = [];
                for (var j = list.length - 1; j >= 0; j--) {
                    arrayOfValues.push(list[j].Value.name)
                    arrayOfLabels.push(list[j].Label.name)
                }
                if (this.Util.hasDuplicates(arrayOfValues)||this.Util.hasDuplicates(arrayOfLabels)) {
                    let msg = this.$translate.instant('duplicate.value.found')
                    this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                    return;
                }
            }


    setNumberField(event,properties){
        let val = event.target.value; 
        if(val <= 0 || val > 999){
            event.target.value = 1;
            properties['Number'].selectedValue =1;
        }
    }
    checkRequired(value, fieldname) {
        if (value == '') {
            var msg = 'Please enter the required field';
            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
            return;
        } else {
            if( fieldname == 'linkAddress' && !this.isValidURL(value)) {
                var msg = 'Please enter the valid Link Address';
                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                return;
            } else if(fieldname == 'linkAddress' && this.isValidURL(value)) {
                this.$http({
                    'url': 'https://safebrowsing.googleapis.com/v4/threatMatches:find?key=AIzaSyDL3Ax5ksdqPSJ8c6BKNma9d3M4VKrk0Xk',
                    'method': 'POST',
                    'headers': {
                        'Content-Type': 'application/json'
                      },
                    'data':   {
                        "client": {
                          "clientId":      "Asite_001",
                          "clientVersion": "1"
                        },
                        "threatInfo": {
                          "threatTypes":      ["MALWARE", "SOCIAL_ENGINEERING"],
                          "platformTypes":    ["WINDOWS"],
                          "threatEntryTypes": ["URL"],
                          "threatEntries": [
                            {"url": value},
                            
                          ]
                        }
                      }
                  }).then(response => {
                    if(Object.keys(response.data).length != 0) {
                        var msg = 'The url entered is not in the safe Browsing lists';
                        this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
                        return;
                    } 
                    else {
                        let selectedItem = this.getSelectedItem();
                        let totalItems = this.Util.getAllControls();
                        if (selectedItem.type === 'Hyperlink') {
                            let filtered = _.filter(totalItems, { uid: selectedItem.uid });
                            for (let i = 0; i < filtered.length; i++) {
                                _.set(filtered[i], "properties.Basic['Value'].selectedValue", value);
                                filtered[i].copiedFrom && (filtered[i].copiedFrom = value);
                            }
                        }
                    }
                  });
            }
        }
    }

    addcolumnName() {
        let self = this;
        let selectedItem = self.getSelectedItem();
        let properties = selectedItem.properties.Association.selectedColumn;
        if (selectedItem.type == 'InlineAssocFiles') {
            selectedItem.properties.Association.AddSetup.clicked = true;
            self.editDropDownSource('6', properties);
        }
        if (selectedItem.type == 'InlineAssocApps') {
            selectedItem.properties.Association.AddSetup.clicked = true;
            self.editDropDownSource('7', properties);
        }
        if (selectedItem.type == 'ViewAssociations') {
            var assocType = selectedItem.properties.Basic['Assoc Type'].selectedValue;
            if(assocType) {
                selectedItem.properties.Association.AddSetup.clicked = true;
                properties = selectedItem.properties.Association[assocType];
                self.editDropDownSource('8', properties);
            }
        }
    }
}

export default angular.module('directives.propertybox', [])
    .component('propertybox', {
        template: require('./propertybox.html'),
        controller: PropertyboxComponent
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/propertybox/propertybox.component.ts